// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    useToast,
//    Box,
//    Stepper,
//    Step,
//    StepIndicator,
//    StepStatus,
//    StepIcon,
//    StepNumber,
//    StepTitle,
//    StepDescription,
//    StepSeparator,
//    Heading,
//    Flex,
//    IconButton,
//    Text,
//    UnorderedList,
//    ListItem,
// } from '@chakra-ui/react';
// import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
// import { useDispatch, useSelector } from 'react-redux';
// import { getCompanyDetailsByGst } from '../../../redux/actions/company';
// // import { getCities } from '../../../redux/actions/city';
// // import { getGroupIDs } from '../../../redux/actions/companyGroup';
// import { renderSwitchControl } from 'utils/DynamicFormData';
// import { WAREHOUSE_TYPE, ITEM_TYPE, ACTION_TYPE } from '../../../variables/company';
// import { getHsn } from '../../../redux/actions/hsn';
// import { getItemGroup } from '../../../redux/actions/itemGroup';
// import { getDaybook } from '../../../redux/actions/daybook';
// import { getUnit } from '../../../redux/actions/uqc';
// import { getWarehouse } from '../../../redux/actions/warehouse';
// import { updateCompanySetting, getCompanies } from '../../../redux/actions/company';
// import { getMainAndSubHsn } from '../../../redux/actions/mainAndSubHsn';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { useBusinessType, useGlobal } from '../../../contexts';
// import { ITEM_DETAILS_TYPES } from '../masters/variables/types';
// import './css.css';

// import { useUser } from '../../../contexts';
// import { Link } from 'react-router-dom';
// import { FaInfo } from 'react-icons/fa';

// // const validationSchema = Yup.object().shape({
// //   name: Yup.string().required('Company Name is required'),
// //   gstRegNo: Yup.string().optional(),
// //   panNo: Yup.string()
// //     .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number format')
// //     .required('PAN is required'),
// //   mobile: Yup.string()
// //     // .matches(
// //     //   /^[6-9]{1}[0-9]{10}$/,
// //     //   'Mobile number must be 10 digits starting with 6-9',
// //     // ) // 10 digits, starting with 6-9
// //     .optional(),
// //   email: Yup.string().email('Invalid email format').optional(),
// //   address1: Yup.string().required('Address 1 is required'),
// //   address2: Yup.string().optional(),
// //   address3: Yup.string().optional(),
// //   cityId: Yup.string().required('City is required'),
// // });

// const steps = [
//    {
//       step: 0,
//       title: 'GST Setting',
//       description: 'Enter GST Setting Here',
//    },
//    {
//       step: 1,
//       title: 'General Setting',
//       description: 'Enter Order/Challan Setting Here',
//    },
//    {
//       step: 2,
//       title: 'Item Setting',
//       description: 'Enter Item Setting Here',
//    },
//    // {
//    //    step: 3,
//    //    title: 'Credit Limit Setting',
//    //    description: 'Enter Credit Limit Setting Here',
//    // },
//    // {
//    //    step: 4,
//    //    title: 'Alert Setting',
//    //    description: 'Enter Alert Setting Here',
//    // },
//    // { title: 'Step 3' },
// ];

// const CompanySettingForm = ({ isOpen, onClose, isEditMode = false, currentRow = null }) => {
//    const [activeStep, setActiveStep] = useState(0);
//    const [errors, setErrors] = useState({});
//    const [isEmailInfoOpen, setIsEmailInfoOpen] = useState(false);
//    const [isPassKeyInfoOpen, setIsPassKeyInfoOpen] = useState(false);
//    const textColor = useColorModeValue('#9E9E9E', '#ffffff');
//    const gstNo = localStorage.getItem('gst');
//    // const cities = useSelector((state) => state.city.list);
//    const daybook = useSelector((state) => state.daybook.list);
//    const company = useSelector((state) => state.company.gstDetail);
//    const itemGroupData = useSelector((state) => state?.itemGroup?.list);
//    const warehouse = useSelector((state) => state?.warehouse?.list);
//    const allHsnData = useSelector((state) => state.hsn.list);
//    const uqc = useSelector((state) => state.uqc.list);
//    const hsnData = allHsnData.filter((record) => record.gstType === 'G');
//    const sacData = allHsnData.filter((record) => record.gstType === 'S');
//    const [showPrevTaxes, setShowPrevTaxes] = useState(false);
//    const { user } = useUser();
//    const toast = useToast();
//    const dispatch = useDispatch();
//    const { businessTypes } = useBusinessType();
//    const { cityList, userGlobalSettingsData } = useGlobal();

//    const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
//    const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
//    const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;

//    // const getDefaultId = useCallback((data, key) => {
//    //   return (
//    //     data?.find((x) => x.name.toLowerCase() === key.toLowerCase())?.id ?? null
//    //   );
//    // }, []);

//    // In your case, you can modify the getDefaultId function as follows:
//    const getDefaultId = useCallback((data, key) => {
//       if (Array.isArray(data)) {
//          return data.find((x) => x.name.toLowerCase() === key.toLowerCase())?.id ?? null;
//       } else {
//          return null;
//       }
//    }, []);

//    const [row, setRow] = useState({
//       //gst fields
//       applyGST: currentRow && currentRow?.gstRegNo ? true : false,
//       GSTApplyDate: new Date('2017-07-01').toISOString().split('T')[0],
//       defaultHSN: hsnData?.find((x) => x.hsn.toLowerCase() === '5407'.toLowerCase())?.id ?? null,
//       defaultSAC: sacData?.find((x) => x.hsn.toLowerCase() === '9988'.toLowerCase())?.id ?? null,
//       prevYearTurnover: 0,
//       eWayUserName: '',
//       eWayPassword: '',
//       eInvoiceUserName: '',
//       eInvoicePassword: '',
//       isSync: false,
//       syncCode: '',
//       syncDaybookId: null,
//       eWayLoginUID: null,
//       eWayLoginPWD: null,
//       GSTNLoginUID: null,
//       GSTNLoginPWD: null,
//       eInvoiceLoginUID: null,
//       eInvoiceLoginPWD: null,
//       passKey: '',
//       invReciptEmail: '',

//       // order / challan
//       enablePurchaseOrder: false,
//       partynoequaltodocno: false,
//       ewayInvoice: false,
//       ewayBill: false,
//       cstTinno: false,
//       vatRegNo: false,
//       csalesTaxNo: false,
//       iSalesTaxno: false,
//       enablePurchaseChallan: businessTypes && businessTypes?.businessType === 'TEXTILE' ? true : false, // business type "TEXTILE" then ture else false
//       enableSaleOrder: false,
//       enableSaleChallan: businessTypes && businessTypes?.businessType === 'TEXTILE' ? true : false, // business type "TEXTILE" then ture else false

//       // item
//       priceLevel: false,
//       priceMatrix: false,
//       warehouseWishStock: false,
//       warehouseInSale: 1, // enum: Before Transaction = 0, Header = 1, Line-Item = 2, Line Details = 3
//       warehouseInPurchase: 1, // enum: Before Transaction, Header, Line-Item, Line Details
//       warehouseInInventory: 1, // enum: Before Transaction, Header, Line-Item, Line Details
//       maxUOM: businessTypes && businessTypes?.businessType === 'TEXTILE' ? 3 : 1, // if basiness type "TEXTILE" then 3 else 1
//       UOM1: businessTypes && businessTypes?.businessType === 'TEXTILE' ? getDefaultId(uqc, 'CUT') : 1,
//       UOM2: businessTypes && businessTypes?.businessType === 'TEXTILE' ? getDefaultId(uqc, 'PIECES') : 1,
//       UOM3: businessTypes && businessTypes?.businessType === 'TEXTILE' ? getDefaultId(uqc, 'METERS') : 1,
//       primaryUnit:
//          businessTypes && businessTypes?.businessType === 'TEXTILE'
//             ? getDefaultId(uqc, 'METERS')
//             : getDefaultId(uqc, 'PIECES'),
//       itemType: 0, // enum: Inventory = 0, Service = 1, Non Inventory = 2, group = 3
//       itemDetailType: null,
//       itemGroupId: getDefaultId(itemGroupData, 'DEFAULT'), // item group id,
//       warehouseId: getDefaultId(warehouse, 'DEFAULT'), // warehouse id

//       // Credit limit
//       enableCreditLimit: false,
//       enableMultiCompanyCreditLimit: false,
//       enableCreditLimitInDays: false,
//       customerCreditAmount: 0,
//       customerCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//       vendorCreditAmount: 0,
//       vendorCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3

//       // Alert
//       negativeCashAlert: false,
//       negativeStockAlert: false,
//       AccountOpeningBalance: false,
//       ItemOpeningBalance: false,
//       ActionOnNegativeStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//       ActionOnMinimumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//       ActionOnMaximumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//       ActionOnReorderStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//    });

//    const clearFormData = () => {
//       setRow({
//          //gst fields
//          applyGST: currentRow && currentRow.gstRegNo ? true : false,
//          GSTApplyDate: '',
//          defaultHSN: '',
//          defaultSAC: '',
//          prevYearTurnover: 0,
//          eWayUserName: '',
//          eWayPassword: '',
//          eInvoiceUserName: '',
//          eInvoicePassword: '',
//          isSync: false,
//          syncCode: '',
//          syncDaybookId: null,
//          eWayLoginUID: null,
//          eWayLoginPWD: null,
//          GSTNLoginUID: null,
//          GSTNLoginPWD: null,
//          eInvoiceLoginUID: null,
//          eInvoiceLoginPWD: null,
//          passKey: '',
//          invReciptEmail: '',

//          // order / challan
//          enablePurchaseOrder: false,
//          partynoequaltodocno: false,
//          ewayInvoice: false,
//          ewayBill: false,
//          cstTinno: false,
//          vatRegNo: false,
//          csalesTaxNo: false,
//          iSalesTaxno: false,
//          enablePurchaseChallan: false, // business type "TEXTILE" then ture else false
//          enableSaleOrder: false,
//          enableSaleChallan: false, // business type "TEXTILE" then ture else false

//          // item
//          priceLevel: false,
//          priceMatrix: false,
//          warehouseWishStock: false,
//          warehouseInSale: 1, // enum: Before Transaction = 0, Header = 1, Line-Item = 2, Line Details = 3
//          warehouseInPurchase: 1, // enum: Before Transaction, Header, Line-Item, Line Details
//          warehouseInInventory: 1, // enum: Before Transaction, Header, Line-Item, Line Details
//          maxUOM: 1, // if basiness type "TEXTILE" then 3 else 1
//          UOM1: 160,
//          UOM2: 175,
//          UOM3: 157,
//          primaryUnit: 160,
//          itemType: 0, // enum: Inventory = 0, Service = 1, Non Inventory = 2, group = 3
//          itemDetailType: null,
//          itemGroup: null, // item group id,
//          warehouse: null, // warehouse id

//          // Credit limit
//          enableCreditLimit: false,
//          enableMultiCompanyCreditLimit: false,
//          enableCreditLimitInDays: false,
//          customerCreditAmount: 0,
//          customerCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//          vendorCreditAmount: 0,
//          vendorCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3

//          // Alert
//          negativeCashAlert: false,
//          negativeStockAlert: false,
//          AccountOpeningBalance: false,
//          ItemOpeningBalance: false,
//          ActionOnNegativeStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//          ActionOnMinimumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//          ActionOnMaximumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//          ActionOnReorderStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
//       });
//       setErrors({});
//    };

//    const handleOnClose = () => {
//       clearFormData();
//       onClose();
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({ ...prev, [field]: value }));
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    const handleSwitchChange = (field) => (event) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: event.target.checked, // Updates boolean value (true/false)
//       }));
//    };

//    const handlePrevious = () => {
//       if (activeStep > 0) {
//          setActiveStep(activeStep - 1);
//       }
//    };

//    // const validateStep = async () => {
//    //   try {
//    //     await validationSchema.validate(row, { abortEarly: false });
//    //     setErrors({});
//    //     return true;
//    //   } catch (err) {
//    //     if (err instanceof Yup.ValidationError) {
//    //       const errorObj = {};
//    //       err.inner.forEach((error) => {
//    //         errorObj[error.path] = error.message;
//    //       });
//    //       setErrors(errorObj);
//    //       return false;
//    //     }
//    //     return false;
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       try {
//          const processedData = {
//             ...row,
//             isSync: row.isSync || false,
//             syncCode: row.syncCode || '',
//             syncDaybookId: row.syncDaybookId || null,
//          };

//          delete processedData.warehouse;
//          if (isEditMode && currentRow?.id) {
//             processedData.id = currentRow.id;
//             await dispatch(updateCompanySetting(processedData));
//          }
//          onClose();
//          await dispatch(getCompanies());
//          setActiveStep(0);
//          clearFormData();
//          // window.location.reload();
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Daybook.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handleSave = async () => {
//       onFormSubmit();
//    };

//    const handleNext = async () => {
//       // const isValid = await validateStep();
//       // if (isValid) {
//       if (activeStep < steps.length - 1) {
//          setActiveStep(activeStep + 1);
//       } else {
//          onFormSubmit();
//       }
//       // } else {
//       //   toast({
//       //     title: 'Validation Error',
//       //     description: 'Please correct the errors.',
//       //     status: 'error',
//       //     duration: 3000,
//       //     isClosable: true,
//       //   });
//       // }
//    };

//    const getCompanyDetailsByGST = useCallback(
//       async (gst) => {
//          if (isOpen) {
//             dispatch(getCompanyDetailsByGst(gst));
//          }
//       },
//       [dispatch],
//    );

//    useEffect(() => {
//       if (gstNo) {
//          getCompanyDetailsByGST(gstNo);
//       }
//    }, [getCompanyDetailsByGST, gstNo]);

//    useEffect(() => {
//       localStorage.setItem('showPrevTaxes', JSON.stringify(showPrevTaxes));
//    }, [showPrevTaxes]);

//    // useEffect(() => {
//    //   dispatch(getGroupIDs());
//    // }, [dispatch]);

//    // useEffect(() => {
//    //   if (cities?.length <= 0 && isOpen) {
//    //     dispatch(getCities());
//    //   }
//    // }, [cities?.length, dispatch, isOpen]);

//    useEffect(() => {
//       if (company) {
//          const address = company && company.pradr ? company.pradr.addr : {};
//          setRow((prev) => ({
//             ...prev,
//             name: company?.tradeNam,
//             gstRegNo: gstNo,
//             address1: `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`,
//             cityId: cityList.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase())?.id,
//             pincode: address?.pncd,
//             panNo: gstNo?.slice(2, 12),
//          }));
//       }
//    }, [cityList, company, gstNo]);

//    // useEffect(() => {
//    //   dispatch(getHsn());
//    //   dispatch(getMainAndSubHsn());
//    //   // dispatch(getUnit());
//    // }, [dispatch]);

//    // useEffect(() => {
//    //   dispatch(getItemGroup());
//    // }, [dispatch]);

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(getUnit());
//          dispatch(getHsn());
//          dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: user?.loginhistory?.companyId }) }));
//          dispatch(getItemGroup({ ...(shouldSendCompanyidItemGroup && { companyIds: user?.loginhistory?.companyId }) }));
//          dispatch(getMainAndSubHsn());
//          if (user && user?.loginhistory?.companyId)
//             dispatch(
//                getDaybook({
//                   companyId: user?.loginhistory?.companyId,
//                   ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
//                }),
//             );
//       }
//    }, [dispatch, isOpen, user]);

//    useEffect(() => {
//       if (isOpen && isEditMode && currentRow) {
//          const setting = currentRow?.setting;
//          const settingData = {
//             //gst fields
//             applyGST: setting?.applyGST,
//             GSTApplyDate:
//                setting && setting?.GSTApplyDate
//                   ? new Date(setting?.GSTApplyDate?.split(' ')[0]).toISOString().split('T')[0]
//                   : new Date('2017-07-01').toISOString().split('T')[0],
//             defaultHSN: setting?.defaultHSN || null,
//             defaultSAC: setting?.defaultSAC || null,
//             prevYearTurnover: setting?.prevYearTurnover || 0,
//             eWayUserName: setting?.eWayUserName || '',
//             eWayPassword: setting?.eWayPassword || '',
//             eInvoiceUserName: setting?.eInvoiceUserName || '',
//             eInvoicePassword: setting?.eInvoicePassword || '',
//             isSync: setting?.isSync || false,
//             syncCode: setting?.syncCode || '',
//             syncDaybookId: setting?.syncDaybookId || null,
//             eWayLoginUID: setting?.eWayLoginUID || null,
//             eWayLoginPWD: setting?.eWayLoginPWD || null,
//             GSTNLoginUID: setting?.GSTNLoginUID || null,
//             GSTNLoginPWD: setting?.GSTNLoginPWD || null,
//             eInvoiceLoginUID: setting?.eInvoiceLoginUID || null,
//             eInvoiceLoginPWD: setting?.eInvoiceLoginPWD || null,
//             passKey: setting?.passKey || '',
//             invReciptEmail: setting?.invReciptEmail || '',

//             // order / challan
//             enablePurchaseOrder: setting?.enablePurchaseOrder,
//             partynoequaltodocno: setting?.partynoequaltodocno,
//             ewayInvoice: setting?.ewayInvoice,
//             ewayBill: setting?.ewayBill,
//             cstTinno: setting?.cstTinno,
//             vatRegNo: setting?.vatRegNo,
//             csalesTaxNo: setting?.csalesTaxNo,
//             iSalesTaxno: setting?.iSalesTaxno,
//             enablePurchaseChallan: setting?.enablePurchaseChallan,
//             enableSaleOrder: setting?.enableSaleOrder,
//             enableSaleChallan: setting?.enableSaleChallan,

//             // item
//             priceLevel: setting?.priceLevel,
//             priceMatrix: setting?.priceMatrix,
//             warehouseWishStock: setting?.warehouseWishStock,
//             warehouseInSale: setting?.warehouseInSale,
//             warehouseInPurchase: setting?.warehouseInPurchase,
//             warehouseInInventory: setting?.warehouseInInventory,
//             maxUOM: setting?.maxUOM,
//             UOM1: setting?.UOM1,
//             UOM2: setting?.UOM2,
//             UOM3: setting?.UOM3,
//             primaryUnit: setting?.primaryUnit,
//             itemType: setting?.itemType,
//             itemDetailType: setting?.itemDetailType,
//             itemGroupId: setting?.itemGroupId > 0 ? setting.itemGroupId : getDefaultId(itemGroupData, 'DEFAULT'),
//             warehouseId: setting?.warehouseId > 0 ? setting.warehouseId : getDefaultId(warehouse, 'DEFAULT'),

//             // Credit limit
//             enableCreditLimit: setting?.enableCreditLimit,
//             enableMultiCompanyCreditLimit: setting?.enableMultiCompanyCreditLimit,
//             enableCreditLimitInDays: setting?.enableCreditLimitInDays,
//             customerCreditAmount: setting?.customerCreditAmount || 0,
//             customerCreditLimitAction: setting?.customerCreditLimitAction,
//             vendorCreditAmount: setting?.vendorCreditAmount || 0,
//             vendorCreditLimitAction: setting?.vendorCreditLimitAction,

//             // Alert
//             negativeCashAlert: setting?.negativeCashAlert,
//             negativeStockAlert: setting?.negativeStockAlert,
//             AccountOpeningBalance: setting?.AccountOpeningBalance,
//             ItemOpeningBalance: setting?.ItemOpeningBalance,
//             ActionOnNegativeStock: setting?.ActionOnNegativeStock,
//             ActionOnMinimumStock: setting?.ActionOnMinimumStock,
//             ActionOnMaximumStock: setting?.ActionOnMaximumStock,
//             ActionOnReorderStock: setting?.ActionOnReorderStock,
//          };

//          setRow(settingData);
//       }
//    }, [currentRow, getDefaultId, isEditMode, isOpen, itemGroupData, warehouse]);

//    const handleFocusMove = (e, nextRef, prevRef) => {
//       console.log("focuse move", e.key, nextRef, prevRef);
//       if (e.key === 'Tab' || e.key === 'Enter') {
//          e.preventDefault(); // Prevent default tab/enter behavior
//          if (e.shiftKey) {
//             // Move to previous input if Shift is pressed
//             prevRef?.current?.focus();
//          } else {
//             // Move to next input
//             nextRef?.current?.focus();
//          }
//       }
//    };

//    const applyGSTRef = useRef(null);
//    const gstRegNoRef = useRef(null);
//    const showPrevTaxesRef = useRef(null);
//    const gstRegDateRef = useRef(null);
//    const defaultHSNRef = useRef(null);
//    const defaultSACRef = useRef(null);
//    const eWayUserNameRef = useRef(null);
//    const eWayPasswordRef = useRef(null);
//    const eInvoiceUserNameRef = useRef(null);
//    const eInvoicePasswordRef = useRef(null);
//    const GSTNLoginUIDRef = useRef(null);
//    const GSTNLoginPWDRef = useRef(null);
//    const ewayBillRef = useRef(null);
//    const ewayInvoiceRef = useRef(null);
//    const iSalesTaxnoRef = useRef(null);
//    const csalesTaxNoRef = useRef(null);
//    const vatRegNoRef = useRef(null);
//    const cstTinnoRef = useRef(null);
//    const invReciptEmailRef = useRef(null);
//    const passKeyRef = useRef(null);
//    const SaveRef = useRef(null);

//    useEffect(() => {
//       console.log("applyGSTRef set");
//       setTimeout(() => {
//          applyGSTRef.current?.focus();
//       }, 100);
//    }, [isOpen]);

//    return (
//       <>
//          <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl">
//             <ModalOverlay />
//             <ModalContent
//                bg={useColorModeValue('white', '#2d3748')}
//                color={useColorModeValue('gray.800', 'white')}
//                borderRadius="20px"
//                p={5}
//                boxShadow="lg">
//                <ModalHeader fontSize="20px" fontWeight="600" p={0} mb={4}>
//                   {isEditMode ? 'Edit Company' : 'Add New Company'}
//                </ModalHeader>
//                <ModalCloseButton />
//                <ModalBody overflowY="auto">
//                   <Grid h="auto" templateRows="repeat(2, 1fr)" templateColumns="repeat(5, 1fr)" gap={2} display="block">
//                      <GridItem rowSpan={2} colSpan={1}>
//                         <Stepper
//                            index={activeStep}
//                            orientation="horizontal"
//                            colorScheme="teal"
//                            border="1px solid"
//                            overflowX="auto"
//                            borderRadius={5}
//                            px={{ base: 2, md: 5, xl: 5 }}
//                            py={{ base: 3, md: 3, xl: 3 }}
//                            mb={{ base: 3, md: 5, xl: 5 }}
//                         // borderTop="1px solid"
//                         >
//                            {steps.map((step, index) => (
//                               <Step key={index}>
//                                  <Box
//                                     flexShrink="1"
//                                     cursor="pointer"
//                                     onClick={() => setActiveStep(index)} // Set active step on click
//                                     justifyItems="center">
//                                     <StepIndicator
//                                        width={{ base: '20px', xl: '30px' }}
//                                        height={{ base: '20px', xl: '30px' }}>
//                                        <StepStatus
//                                           complete={<StepIcon />}
//                                           incomplete={
//                                              <StepNumber fontSize={{ base: '12px', md: '14px', xl: '16px' }} />
//                                           }
//                                           active={<StepNumber fontSize={{ base: '12px', md: '14px', xl: '16px' }} />}
//                                        />
//                                     </StepIndicator>
//                                     <StepTitle fontSize={{ base: '0px', md: '14px', xl: '14px' }} textAlign="center">
//                                        {step.title}
//                                     </StepTitle>
//                                     {/* <StepDescription style={{ marginLeft: 22 }}>
//                           {step.description}
//                         </StepDescription> */}
//                                  </Box>
//                                  <StepSeparator />
//                               </Step>
//                            ))}
//                         </Stepper>
//                      </GridItem>
//                      <GridItem colSpan={4}>
//                         {/* <Box mb={5}>
//                   <Heading>
//                     {steps.find((x) => x.step === activeStep)?.title}
//                   </Heading>
//                 </Box> */}
//                         <Grid
//                            templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
//                            gap={3}>
//                            {activeStep === 0 && (
//                               <>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'applyGST',
//                                        'Apply GST',
//                                        {
//                                           isChecked: row.applyGST,
//                                           onChange: handleSwitchChange('applyGST'),
//                                           ref: applyGSTRef,
//                                           onKeyDown: (e) => handleFocusMove(e, row.applyGST ? gstRegDateRef : showPrevTaxesRef, null),
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>

//                                  {/* Conditionally render these fields only when applyGST is true */}
//                                  {row.applyGST && (
//                                     <>
//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'GSTApplyDate',
//                                              'GST Reg Date',
//                                              {
//                                                 value: row.GSTApplyDate,
//                                                 onChange: (e) => handleInputChange('GSTApplyDate', e.target.value),
//                                                 ref: gstRegDateRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, defaultHSNRef, applyGSTRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'date',
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem zIndex="30" className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'defaultHSN',
//                                              'Default HSN',
//                                              hsnData?.map((item) => ({
//                                                 id: item.id,
//                                                 name: item.hsn,
//                                              })),
//                                              {
//                                                 value: row.defaultHSN,
//                                                 onChange: (value) => handleInputChange('defaultHSN', value),
//                                                 ref: defaultHSNRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, defaultSACRef, gstRegDateRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              false,
//                                              'Select HSN',
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'defaultSAC',
//                                              'Default SAC',
//                                              sacData?.map((item) => ({
//                                                 id: item.id,
//                                                 name: item.hsn,
//                                              })),
//                                              {
//                                                 value: row.defaultSAC,
//                                                 onChange: (value) => handleInputChange('defaultSAC', value),
//                                                 ref: defaultSACRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, eWayUserNameRef, defaultHSNRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              false,
//                                              'Select SAC',
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'eWayUserName',
//                                              'E-way Bill user',
//                                              {
//                                                 value: row.eWayUserName,
//                                                 onChange: (e) => handleInputChange('eWayUserName', e.target.value),
//                                                 ref: eWayUserNameRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, eWayPasswordRef, defaultSACRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'eWayPassword',
//                                              'E-way Bill Password',
//                                              {
//                                                 value: row.eWayPassword,
//                                                 onChange: (e) => handleInputChange('eWayPassword', e.target.value),
//                                                 ref: eWayPasswordRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, eInvoiceUserNameRef, eWayUserNameRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'eInvoiceUserName',
//                                              'E invoice user',
//                                              {
//                                                 value: row.eInvoiceUserName,
//                                                 onChange: (e) => handleInputChange('eInvoiceUserName', e.target.value),
//                                                 ref: eInvoiceUserNameRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, eInvoicePasswordRef, eWayPasswordRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'eInvoicePassword',
//                                              'E invoice Password',
//                                              {
//                                                 value: row.eInvoicePassword,
//                                                 onChange: (e) => handleInputChange('eInvoicePassword', e.target.value),
//                                                 ref: eInvoicePasswordRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, GSTNLoginUIDRef, eInvoiceUserNameRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'GSTNLoginUID',
//                                              'GST User Name',
//                                              {
//                                                 value: row.GSTNLoginUID,
//                                                 onChange: (e) => handleInputChange('GSTNLoginUID', e.target.value),
//                                                 ref: GSTNLoginUIDRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, GSTNLoginPWDRef, eInvoicePasswordRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'GSTNLoginPWD',
//                                              'GST User Password',
//                                              {
//                                                 value: row.GSTNLoginPWD,
//                                                 onChange: (e) => handleInputChange('GSTNLoginPWD', e.target.value),
//                                                 ref: GSTNLoginPWDRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, ewayBillRef, GSTNLoginUIDRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </GridItem>
//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'ewayBill',
//                                              'E-way Bill',
//                                              {
//                                                 isChecked: row.ewayBill,
//                                                 onChange: handleSwitchChange('ewayBill'),
//                                                 ref: ewayBillRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, ewayInvoiceRef, GSTNLoginPWDRef),
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false,
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'ewayInvoice',
//                                              'E-Invoice',
//                                              {
//                                                 isChecked: row.ewayInvoice,
//                                                 onChange: handleSwitchChange('ewayInvoice'),
//                                                 ref: ewayInvoiceRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, showPrevTaxesRef, ewayBillRef),
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false,
//                                              false,
//                                           )}
//                                        </GridItem>
//                                     </>
//                                  )}

//                                  {/* ADD PREV. TAXES Switch - Front-end only */}
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'showPrevTaxes',
//                                        'ADD PREV. TAXES',
//                                        {
//                                           isChecked: showPrevTaxes,
//                                           onChange: (e) => setShowPrevTaxes(e.target.checked),
//                                           ref: showPrevTaxesRef,
//                                           onKeyDown: (e) => handleFocusMove(e, showPrevTaxes ? iSalesTaxnoRef : invReciptEmailRef, row.applyGST ? ewayInvoiceRef : applyGSTRef),
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>

//                                  {/* Previous Taxes Fields - Only visible when showPrevTaxes is true */}
//                                  {showPrevTaxes && (
//                                     <>
//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'iSalesTaxno',
//                                              'I Sales TaxNo',
//                                              {
//                                                 isChecked: row.iSalesTaxno,
//                                                 onChange: handleSwitchChange('iSalesTaxno'),
//                                                 ref: iSalesTaxnoRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, csalesTaxNoRef, showPrevTaxesRef),
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false,
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'csalesTaxNo',
//                                              'CSales Tax No',
//                                              {
//                                                 isChecked: row.csalesTaxNo,
//                                                 onChange: handleSwitchChange('csalesTaxNo'),
//                                                 ref: csalesTaxNoRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, vatRegNoRef, iSalesTaxnoRef),
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false,
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'vatRegNo',
//                                              'Vat Reg No',
//                                              {
//                                                 isChecked: row.vatRegNo,
//                                                 onChange: handleSwitchChange('vatRegNo'),
//                                                 ref: vatRegNoRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, cstTinnoRef, csalesTaxNoRef),
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false,
//                                              false,
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'cstTinno',
//                                              'CstTin no',
//                                              {
//                                                 isChecked: row.cstTinno,
//                                                 onChange: handleSwitchChange('cstTinno'),
//                                                 ref: cstTinnoRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, invReciptEmailRef, vatRegNoRef),
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false,
//                                              false,
//                                           )}
//                                        </GridItem>
//                                     </>
//                                  )}
//                                  <GridItem className="seperator-width">
//                                     <Flex align="center" gap={2}>
//                                        <Box flex="1">
//                                           {DynamicInput(
//                                              'invReciptEmail',
//                                              'Email',
//                                              {
//                                                 value: row.invReciptEmail,
//                                                 onChange: (e) => handleInputChange('invReciptEmail', e.target.value),
//                                                 ref: invReciptEmailRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, passKeyRef, showPrevTaxes ? cstTinnoRef : showPrevTaxesRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'email',
//                                              false,
//                                           )}
//                                        </Box>
//                                        <IconButton
//                                           icon={<FaInfo />}
//                                           size="sm"
//                                           variant="ghost"
//                                           colorScheme="blue"
//                                           onClick={() => setIsEmailInfoOpen(true)}
//                                           aria-label="Email information"
//                                        />
//                                     </Flex>
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     <Flex align="center" gap={2}>
//                                        <Box flex="1">
//                                           {DynamicInput(
//                                              'passKey',
//                                              'Pass Key',
//                                              {
//                                                 value: row.passKey,
//                                                 onChange: (e) => handleInputChange('passKey', e.target.value),
//                                                 ref: passKeyRef,
//                                                 onKeyDown: (e) => handleFocusMove(e, SaveRef, invReciptEmailRef),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'text',
//                                              false,
//                                           )}
//                                        </Box>
//                                        <IconButton
//                                           icon={<FaInfo />}
//                                           size="sm"
//                                           variant="ghost"
//                                           colorScheme="blue"
//                                           onClick={() => setIsPassKeyInfoOpen(true)}
//                                           aria-label="Pass Key information"
//                                        />
//                                     </Flex>
//                                  </GridItem>
//                               </>
//                            )}

//                            {activeStep === 1 && (
//                               <>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'partyNoEqualToDocno',
//                                        'Party Bill No Equal To Doc No',
//                                        {
//                                           isChecked: row.partynoequaltodocno,
//                                           onChange: handleSwitchChange('partynoequaltodocno'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'enablePurchaseOrder',
//                                        'Enable Purchase Order',
//                                        {
//                                           isChecked: row.enablePurchaseOrder,
//                                           onChange: handleSwitchChange('enablePurchaseOrder'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'enablePurchaseChallan',
//                                        'Enable Purchase Challan',
//                                        {
//                                           isChecked: row.enablePurchaseChallan,
//                                           onChange: handleSwitchChange('enablePurchaseChallan'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'enableSaleOrder',
//                                        'Enable Sale Order',
//                                        {
//                                           isChecked: row.enableSaleOrder,
//                                           onChange: handleSwitchChange('enableSaleOrder'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'enableSaleChallan',
//                                        'Enable Sale Challan',
//                                        {
//                                           isChecked: row.enableSaleChallan,
//                                           onChange: handleSwitchChange('enableSaleChallan'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'warehouseWishStock',
//                                        'Warehouse Wish Stock',
//                                        {
//                                           isChecked: row.warehouseWishStock,
//                                           onChange: handleSwitchChange('warehouseWishStock'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>

//                                  {/* Show warehouse dropdowns only when warehouseWishStock is enabled */}
//                                  {row.warehouseWishStock && (
//                                     <>
//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'warehouseId',
//                                              'Warehouse',
//                                              warehouse,
//                                              {
//                                                 value: row.warehouseId,
//                                                 onChange: (value) => handleInputChange('warehouseId', value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              false, // isRequired
//                                              'Select Warehouse', // placeholder
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'warehouseInSale',
//                                              'Warehouse In Sale',
//                                              WAREHOUSE_TYPE,
//                                              {
//                                                 value: row.warehouseInSale,
//                                                 onChange: (value) => handleInputChange('warehouseInSale', value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              false, // isRequired
//                                              'Select header', // placeholder
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'warehouseInPurchase',
//                                              'Warehouse In Purchase',
//                                              WAREHOUSE_TYPE,
//                                              {
//                                                 value: row.warehouseInPurchase,
//                                                 onChange: (value) => handleInputChange('warehouseInPurchase', value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              false, // isRequired
//                                              'Select header', // placeholder
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'warehouseInInventory',
//                                              'Warehouse In Inventory',
//                                              WAREHOUSE_TYPE,
//                                              {
//                                                 value: row.warehouseInInventory,
//                                                 onChange: (value) => handleInputChange('warehouseInInventory', value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              false, // isRequired
//                                              'Select header', // placeholder
//                                           )}
//                                        </GridItem>
//                                     </>
//                                  )}

//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'enableCreditLimit',
//                                        'Enable Credit Limit',
//                                        {
//                                           isChecked: row.enableCreditLimit,
//                                           onChange: handleSwitchChange('enableCreditLimit'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>

//                                  {row.enableCreditLimit && (
//                                     <>
//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'enableMultiCompanyCreditLimit',
//                                              'Enable Multi Company Credit Limit',
//                                              {
//                                                 isChecked: row.enableMultiCompanyCreditLimit,
//                                                 onChange: handleSwitchChange('enableMultiCompanyCreditLimit'), // Pass field name dynamically
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false, // Not required
//                                              false, // Not disabled
//                                           )}
//                                        </GridItem>

//                                        <GridItem className="seperator-width">
//                                           {renderSwitchControl(
//                                              'enableCreditLimitInDays',
//                                              'Enable Credit Limit In Days',
//                                              {
//                                                 isChecked: row.enableCreditLimitInDays,
//                                                 onChange: handleSwitchChange('enableCreditLimitInDays'), // Pass field name dynamically
//                                              },
//                                              errors,
//                                              'gray.700',
//                                              false, // Not required
//                                              false, // Not disabled
//                                           )}
//                                        </GridItem>
//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'customerCreditAmount',
//                                              'Customer Credit Amount',
//                                              {
//                                                 value: row.customerCreditAmount,
//                                                 onChange: (e) =>
//                                                    handleInputChange('customerCreditAmount', e.target.value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'number',
//                                              false,
//                                           )}
//                                        </GridItem>
//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'customerCreditLimitAction',
//                                              'Customer Credit Limit Action',
//                                              ACTION_TYPE,
//                                              {
//                                                 value: row.customerCreditLimitAction,
//                                                 onChange: (value) =>
//                                                    handleInputChange('customerCreditLimitAction', value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              true, // isRequired
//                                              'Select Action', // placeholder
//                                           )}
//                                        </GridItem>
//                                        <GridItem className="seperator-width">
//                                           {DynamicInput(
//                                              'vendorCreditAmount',
//                                              'Vendor Credit Amount',
//                                              {
//                                                 value: row.vendorCreditAmount,
//                                                 onChange: (e) =>
//                                                    handleInputChange('vendorCreditAmount', e.target.value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              'number',
//                                              false,
//                                           )}
//                                        </GridItem>
//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'vendorCreditLimitAction',
//                                              'Vendor Credit Limit Action',
//                                              ACTION_TYPE,
//                                              {
//                                                 value: row.vendorCreditLimitAction,
//                                                 onChange: (value) =>
//                                                    handleInputChange('vendorCreditLimitAction', value),
//                                              },
//                                              errors,
//                                              textColor,
//                                              true, // isRequired
//                                              'Select Action', // placeholder
//                                           )}
//                                        </GridItem>
//                                     </>
//                                  )}
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'negativeCashAlert',
//                                        'Negative Cash Alert',
//                                        {
//                                           isChecked: row.negativeCashAlert,
//                                           onChange: handleSwitchChange('negativeCashAlert'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'negativeStockAlert',
//                                        'Negative Stock Alert',
//                                        {
//                                           isChecked: row.negativeStockAlert,
//                                           onChange: handleSwitchChange('negativeStockAlert'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>

//                                  {/* <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'ItemOpeningBalance',
//                                        'Item Opening Balance',
//                                        {
//                                           isChecked: row.ItemOpeningBalance,
//                                           onChange: handleSwitchChange('ItemOpeningBalance'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem> */}

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'ActionOnNegativeStock',
//                                        'Action On Negative Stock',
//                                        ACTION_TYPE,
//                                        {
//                                           value: row.ActionOnNegativeStock,
//                                           onChange: (value) => handleInputChange('ActionOnNegativeStock', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        true, // isRequired
//                                        'Select Action', // placeholder
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'ActionOnMinimumStock',
//                                        'Action On Minimum Stock',
//                                        ACTION_TYPE,
//                                        {
//                                           value: row.ActionOnMinimumStock,
//                                           onChange: (value) => handleInputChange('ActionOnMinimumStock', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        true, // isRequired
//                                        'Select Action', // placeholder
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'ActionOnMaximumStock',
//                                        'Action On Maximum Stock',
//                                        ACTION_TYPE,
//                                        {
//                                           value: row.ActionOnMaximumStock,
//                                           onChange: (value) => handleInputChange('ActionOnMaximumStock', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        true, // isRequired
//                                        'Select Action', // placeholder
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'ActionOnReorderStock',
//                                        'Action On Reorder Stock',
//                                        ACTION_TYPE,
//                                        {
//                                           value: row.ActionOnReorderStock,
//                                           onChange: (value) => handleInputChange('ActionOnReorderStock', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        true, // isRequired
//                                        'Select Action', // placeholder
//                                     )}
//                                  </GridItem>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'isSync',
//                                        'Sync',
//                                        {
//                                           isChecked: row.isSync,
//                                           onChange: handleSwitchChange('isSync'),
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {DynamicInput(
//                                        'syncCode',
//                                        'Sync Code',
//                                        {
//                                           value: row.syncCode,
//                                           onChange: (e) => handleInputChange('syncCode', e.target.value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        'text',
//                                        false,
//                                        true,
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'syncDaybookId',
//                                        'Sync Daybook',
//                                        daybook,
//                                        {
//                                           value: row.syncDaybookId,
//                                           onChange: (value) => handleInputChange('syncDaybookId', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        'Select SAC',
//                                     )}
//                                  </GridItem>
//                               </>
//                            )}

//                            {activeStep === 2 && (
//                               <>
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'priceLevel',
//                                        'Price Level',
//                                        {
//                                           isChecked: row.priceLevel,
//                                           onChange: handleSwitchChange('priceLevel'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'priceMatrix',
//                                        'Price Matrix',
//                                        {
//                                           isChecked: row.priceMatrix,
//                                           onChange: handleSwitchChange('priceMatrix'), // Pass field name dynamically
//                                        },
//                                        errors,
//                                        'gray.700',
//                                        false, // Not required
//                                        false, // Not disabled
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {DynamicInput(
//                                        'maxUOM',
//                                        'Max UOM',
//                                        {
//                                           value: row.maxUOM,
//                                           onChange: (e) => handleInputChange('maxUOM', e.target.value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        'number',
//                                        false,
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'UOM1',
//                                        'UOM 1',
//                                        uqc,
//                                        {
//                                           value: row.UOM1,
//                                           onChange: (value) => handleInputChange('UOM1', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false, // isRequired
//                                        'Select UOM 1', // placeholder
//                                     )}
//                                  </GridItem>

//                                  {row.maxUOM > 1 ? (
//                                     <GridItem className="seperator-width">
//                                        {renderDynamicDropdown(
//                                           'UOM2',
//                                           'UOM 2',
//                                           uqc,
//                                           {
//                                              value: row.UOM2,
//                                              onChange: (value) => handleInputChange('UOM2', value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                           'Select UOM 2', // placeholder
//                                        )}
//                                     </GridItem>
//                                  ) : null}

//                                  {row.maxUOM >= 3 ? (
//                                     <GridItem className="seperator-width">
//                                        {renderDynamicDropdown(
//                                           'UOM3',
//                                           'UOM 3',
//                                           uqc,
//                                           {
//                                              value: row.UOM3,
//                                              onChange: (value) => handleInputChange('UOM3', value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                           'Select UOM 3', // placeholder
//                                        )}
//                                     </GridItem>
//                                  ) : null}

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'primaryUnit',
//                                        'Primary Unit',
//                                        uqc,
//                                        {
//                                           value: row.primaryUnit,
//                                           onChange: (value) => handleInputChange('primaryUnit', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false, // isRequired
//                                        'Select Primary Unit', // placeholder
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {/* {renderSelectFormControl(
//                           'itemType',
//                           'Item Type',
//                           ITEM_TYPE,
//                           {
//                             value: row.itemType,
//                             onChange: (value) =>
//                               handleInputChange('itemType', value),
//                           },
//                           errors,
//                           textColor,
//                           false, // isRequired
//                           'Select item type', // placeholder
//                         )} */}

//                                     {renderDynamicDropdown(
//                                        'itemType',
//                                        'Item Type',
//                                        ITEM_TYPE,
//                                        {
//                                           value: row.itemType,
//                                           onChange: (value) => handleInputChange('itemType', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false, // isRequired
//                                        'Select Item Type', // placeholder
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'itemGroupId',
//                                        'Item Group',
//                                        itemGroupData,
//                                        {
//                                           value: row.itemGroupId,
//                                           onChange: (value) => handleInputChange('itemGroupId', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false, // isRequired
//                                        'Select Item Group', // placeholder
//                                     )}
//                                  </GridItem>

//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'itemDetailType',
//                                        'Item Details Type',
//                                        ITEM_DETAILS_TYPES,
//                                        {
//                                           value: row.itemDetailType,
//                                           onChange: (value) => handleInputChange('itemDetailType', value),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false, // isRequired
//                                        'Select Item Details Types', // placeholder
//                                     )}
//                                  </GridItem>
//                               </>
//                            )}
//                         </Grid>
//                      </GridItem>
//                   </Grid>
//                </ModalBody>
//                <ModalFooter>
//                   {activeStep > 0 && (
//                      <Button onClick={handlePrevious} variant="ghost" colorScheme="teal" mr={3}>
//                         Previous
//                      </Button>
//                   )}
//                   <Button onClick={handleNext} colorScheme="green" variant="ghost" ml={3}>
//                      Next
//                   </Button>
//                   <Button onClick={handleSave} ref={SaveRef} colorScheme="green" ml={3}>
//                      Save
//                   </Button>
//                   <Button variant="ghost" onClick={handleOnClose} ml={3}>
//                      Cancel
//                   </Button>
//                </ModalFooter>
//             </ModalContent>
//          </Modal>

//          <Modal isOpen={isEmailInfoOpen} onClose={() => setIsEmailInfoOpen(false)} size="lg">
//             <ModalOverlay />
//             <ModalContent>
//                <ModalHeader>Custom Email Information</ModalHeader>
//                <ModalCloseButton />
//                <ModalBody pb={6}>
//                   <Text>
//                      Enter a custom email and its app-pass key to send invoices from your own address. If no custom
//                      email is provided, invoices will be sent from the default system email.
//                   </Text>
//                </ModalBody>
//             </ModalContent>
//          </Modal>

//          {/* Pass Key Info Modal */}
//          <Modal isOpen={isPassKeyInfoOpen} onClose={() => setIsPassKeyInfoOpen(false)} size="xl">
//             <ModalOverlay />
//             <ModalContent>
//                <ModalHeader>How to Generate a Google App Password</ModalHeader>
//                <ModalCloseButton />
//                <ModalBody pb={6}>
//                   <Text fontWeight="bold" mb={2}>
//                      Follow these steps:
//                   </Text>

//                   <Box mb={4}>
//                      <Text fontWeight="semibold" mb={2}>
//                         1. Enable 2-Step Verification:
//                      </Text>
//                      <UnorderedList ml={6} spacing={2}>
//                         <ListItem>
//                            Visit Google Account Security Settings:{' '}
//                            <Link to="https://myaccount.google.com/security" target="_blank" color="blue.500" isExternal>
//                               <Text color="blue.500"> https://myaccount.google.com/security</Text>
//                            </Link>
//                         </ListItem>
//                         <ListItem>
//                            Under "Signing in to Google," click on <strong>2-Step Verification</strong> and follow the
//                            prompts to set it up.
//                         </ListItem>
//                      </UnorderedList>
//                   </Box>

//                   <Box mb={4}>
//                      <Text fontWeight="semibold" mb={2}>
//                         2. Generate the App Password:
//                      </Text>
//                      <UnorderedList ml={6} spacing={2}>
//                         <ListItem>
//                            After enabling 2-Step Verification, return to the App Passwords page:{' '}
//                            <Link to="https://myaccount.google.com/apppasswords" target="_blank" isExternal>
//                               <Text color="blue.500">https://myaccount.google.com/apppasswords</Text>
//                            </Link>
//                         </ListItem>
//                         <ListItem>You may be prompted to sign in again.</ListItem>
//                         <ListItem>
//                            Under "Select app," choose <strong>Mail</strong>.
//                         </ListItem>
//                         <ListItem>
//                            Under "Select device," choose <strong>Other (Custom name)</strong>.
//                         </ListItem>
//                         <ListItem>
//                            Enter a name (e.g., "mailer") and click <strong>Generate</strong>.
//                         </ListItem>
//                         <ListItem>
//                            A 16-character app password will appear. <strong>Copy this password</strong>.
//                         </ListItem>
//                      </UnorderedList>
//                   </Box>

//                   <Box bg="yellow.50" p={4} borderRadius="md" borderLeft="4px solid" borderColor="yellow.400">
//                      <Text fontWeight="bold" mb={2}>
//                         Important Notes:
//                      </Text>
//                      <UnorderedList spacing={2}>
//                         <ListItem>App passwords are only available if 2-Step Verification is enabled.</ListItem>
//                         <ListItem>
//                            If you change your Google account password, previously generated app passwords will be
//                            revoked.
//                         </ListItem>
//                      </UnorderedList>
//                   </Box>
//                </ModalBody>
//             </ModalContent>
//          </Modal>
//       </>
//    );
// };

// export default CompanySettingForm;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   useToast,
   useColorMode,
   useDisclosure,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyDetailsByGst } from '../../../redux/actions/company';
// import { getCities } from '../../../redux/actions/city';
// import { getGroupIDs } from '../../../redux/actions/companyGroup';
import { renderSwitchControl } from 'utils/DynamicFormData';
import { WAREHOUSE_TYPE, ITEM_TYPE, ACTION_TYPE } from '../../../variables/company';
import { getHsn } from '../../../redux/actions/hsn';
import { getItemGroup } from '../../../redux/actions/itemGroup';
import { getDaybook } from '../../../redux/actions/daybook';
import { getUnit } from '../../../redux/actions/uqc';
import { getWarehouse } from '../../../redux/actions/warehouse';
import { updateCompanySetting, getCompanies } from '../../../redux/actions/company';
import { getMainAndSubHsn } from '../../../redux/actions/mainAndSubHsn';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { useBusinessType, useGlobal } from '../../../contexts';
import { ITEM_DETAILS_TYPES } from '../masters/variables/types';
import './css.css';
import Settings from '../../admin/settings/setting';
import { useUser } from '../../../contexts';
import { FaInfo } from 'react-icons/fa';
import QrCodeModal from '../settings/QrCodesetting';
import { id } from 'zod/v4/locales';
import { last } from 'lodash';

const steps = [
   {
      step: 0,
      title: 'GST Setting',
      description: 'Enter GST Setting Here',
   },
   {
      step: 1,
      title: 'General Setting',
      description: 'Enter Order/Challan Setting Here',
   },
   {
      step: 2,
      title: 'Item Setting',
      description: 'Enter Item Setting Here',
   },
];

const WhatsAppType = [
   {
      id: 0,
      label: 'OFFICIAL 09',
   },
   {
      id: 1,
      label: 'CUSTOM API (11za)',
   },
   {
      id: 2,
      label: 'UN OFFICIAL',
   },
];
const ReportFrequencyType = [
   {
      id: 0,
      label: 'Daily',
   },
   {
      id: 1,
      label: 'Weekly',
   },
   {
      id: 2,
      label: 'Monthly',
   },
];

const WeekDaysType = [
   {
      id: 0,
      label: 'Sunday',
   },
   {
      id: 1,
      label: 'Monday',
   },
   {
      id: 2,
      label: 'Tuesday',
   },
   {
      id: 3,
      label: 'Wednesday',
   },
   {
      id: 4,
      label: 'Thursday',
   },
   {
      id: 5,
      label: 'Friday',
   },
   {
      id: 6,
      label: 'Saturday',
   },
];

const CompanySettingForm = ({ isOpen, onClose, isEditMode = false, currentRow = null }) => {
   const [activeStep, setActiveStep] = useState(0);
   const [errors, setErrors] = useState({});
   const [isEmailInfoOpen, setIsEmailInfoOpen] = useState(false);
   const [isPassKeyInfoOpen, setIsPassKeyInfoOpen] = useState(false);
   const { isOpen: isOpenQrCode, onOpen: onOpenQrCode, onClose: onCloseQrCode } = useDisclosure();
   const [messageFormat, setMessageFormat] = useState('');
   const [error, setError] = useState('');
   const textareaRef = useRef(null);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const gstNo = localStorage.getItem('gst');
   // const cities = useSelector((state) => state.city.list);
   const daybook = useSelector((state) => state.daybook.list);
   const company = useSelector((state) => state.company.gstDetail);
   const itemGroupData = useSelector((state) => state?.itemGroup?.list);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   const allHsnData = useSelector((state) => state.hsn.list);
   const uqc = useSelector((state) => state.uqc.list);
   const hsnData = allHsnData.filter((record) => record.gstType === 'G');
   const sacData = allHsnData.filter((record) => record.gstType === 'S');
   const [showPrevTaxes, setShowPrevTaxes] = useState(false);
   const { user } = useUser();
   const toast = useToast();
   const dispatch = useDispatch();
   const { businessTypes } = useBusinessType();
   const { cityList, userGlobalSettingsData } = useGlobal();
   const highlightRef = useRef(null);

   const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;

   // const getDefaultId = useCallback((data, key) => {
   //   return (
   //     data?.find((x) => x.name.toLowerCase() === key.toLowerCase())?.id ?? null
   //   );
   // }, []);

   // In your case, you can modify the getDefaultId function as follows:
   const getDefaultId = useCallback((data, key) => {
      if (Array.isArray(data)) {
         return data.find((x) => x.name.toLowerCase() === key.toLowerCase())?.id ?? null;
      } else {
         return null;
      }
   }, []);

   const [row, setRow] = useState({
      //gst fields
      applyGST: currentRow && currentRow?.gstRegNo ? true : false,
      GSTApplyDate: new Date('2017-07-01').toISOString().split('T')[0],
      defaultHSN: hsnData?.find((x) => x.hsn.toLowerCase() === '5407'.toLowerCase())?.id ?? null,
      defaultSAC: sacData?.find((x) => x.hsn.toLowerCase() === '9988'.toLowerCase())?.id ?? null,
      prevYearTurnover: 0,
      eWayUserName: '',
      url_custom: '',
      authToken_custom: '',
      instantId_custom: '',
      accessKey_custom: '',
      eWayPassword: '',
      eInvoiceUserName: '',
      eInvoicePassword: '',
      isSync: false,
      syncCode: '',
      syncDaybookId: null,
      whatsAppFrom: 0,
      eWayLoginUID: null,
      eWayLoginPWD: null,
      GSTNLoginUID: null,
      GSTNLoginPWD: null,
      eInvoiceLoginUID: null,
      eInvoiceLoginPWD: null,
      passKey: '',
      invReciptEmail: '',

      // order / challan
      enablePurchaseOrder: false,
      partynoequaltodocno: false,
      ewayInvoice: false,
      ewayBill: false,
      cstTinno: false,
      vatRegNo: false,
      csalesTaxNo: false,
      iSalesTaxno: false,
      enablePurchaseChallan: businessTypes && businessTypes?.businessType === 'TEXTILE' ? true : false, // business type "TEXTILE" then ture else false
      enableSaleOrder: false,
      enableSaleChallan: businessTypes && businessTypes?.businessType === 'TEXTILE' ? true : false, // business type "TEXTILE" then ture else false

      // item
      priceLevel: false,
      priceMatrix: false,
      warehouseWishStock: false,
      warehouseInSale: 1, // enum: Before Transaction = 0, Header = 1, Line-Item = 2, Line Details = 3
      warehouseInPurchase: 1, // enum: Before Transaction, Header, Line-Item, Line Details
      warehouseInInventory: 1, // enum: Before Transaction, Header, Line-Item, Line Details
      maxUOM: businessTypes && businessTypes?.businessType === 'TEXTILE' ? 3 : 1, // if basiness type "TEXTILE" then 3 else 1
      UOM1: businessTypes && businessTypes?.businessType === 'TEXTILE' ? getDefaultId(uqc, 'CUT') : 1,
      UOM2: businessTypes && businessTypes?.businessType === 'TEXTILE' ? getDefaultId(uqc, 'PIECES') : 1,
      UOM3: businessTypes && businessTypes?.businessType === 'TEXTILE' ? getDefaultId(uqc, 'METERS') : 1,
      primaryUnit:
         businessTypes && businessTypes?.businessType === 'TEXTILE'
            ? getDefaultId(uqc, 'METERS')
            : getDefaultId(uqc, 'PIECES'),
      itemType: 0, // enum: Inventory = 0, Service = 1, Non Inventory = 2, group = 3
      itemDetailType: null,
      notifyCustomTemp: '',
      itemGroupId: getDefaultId(itemGroupData, 'DEFAULT'), // item group id,
      warehouseId: getDefaultId(warehouse, 'DEFAULT'), // warehouse id

      // Credit limit
      enableCreditLimit: false,
      enableMultiCompanyCreditLimit: false,
      enableCreditLimitInDays: false,
      customerCreditAmount: 0,
      customerCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
      vendorCreditAmount: 0,
      vendorCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3

      // Alert
      negativeCashAlert: false,
      negativeStockAlert: false,
      AccountOpeningBalance: false,
      ItemOpeningBalance: false,
      ActionOnNegativeStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
      ActionOnMinimumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
      ActionOnMaximumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
      ActionOnReorderStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
   });

   const clearFormData = useCallback(() => {
      setRow({
         //gst fields
         applyGST: currentRow && currentRow.gstRegNo ? true : false,
         GSTApplyDate: '',
         defaultHSN: '',
         defaultSAC: '',
         prevYearTurnover: 0,
         eWayUserName: '',
         url_custom: '',
         authToken_custom: '',
         instantId_custom: '',
         accessKey_custom: '',
         eWayPassword: '',
         eInvoiceUserName: '',
         eInvoicePassword: '',
         isSync: false,
         syncCode: '',
         syncDaybookId: null,
         whatsAppFrom: 0,
         eWayLoginUID: null,
         eWayLoginPWD: null,
         GSTNLoginUID: null,
         GSTNLoginPWD: null,
         eInvoiceLoginUID: null,
         eInvoiceLoginPWD: null,
         passKey: '',
         invReciptEmail: '',

         // order / challan
         enablePurchaseOrder: false,
         partynoequaltodocno: false,
         ewayInvoice: false,
         ewayBill: false,
         cstTinno: false,
         vatRegNo: false,
         csalesTaxNo: false,
         iSalesTaxno: false,
         enablePurchaseChallan: false, // business type "TEXTILE" then ture else false
         enableSaleOrder: false,
         enableSaleChallan: false, // business type "TEXTILE" then ture else false

         // item
         priceLevel: false,
         priceMatrix: false,
         warehouseWishStock: false,
         warehouseInSale: 1, // enum: Before Transaction = 0, Header = 1, Line-Item = 2, Line Details = 3
         warehouseInPurchase: 1, // enum: Before Transaction, Header, Line-Item, Line Details
         warehouseInInventory: 1, // enum: Before Transaction, Header, Line-Item, Line Details
         maxUOM: 1, // if basiness type "TEXTILE" then 3 else 1
         UOM1: 160,
         UOM2: 175,
         UOM3: 157,
         primaryUnit: 160,
         itemType: 0, // enum: Inventory = 0, Service = 1, Non Inventory = 2, group = 3
         itemDetailType: null,
         notifyCustomTemp: '',
         itemGroup: null, // item group id,
         warehouse: null, // warehouse id

         // Credit limit
         enableCreditLimit: false,
         enableMultiCompanyCreditLimit: false,
         enableCreditLimitInDays: false,
         customerCreditAmount: 0,
         customerCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
         vendorCreditAmount: 0,
         vendorCreditLimitAction: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3

         // Alert
         negativeCashAlert: false,
         negativeStockAlert: false,
         AccountOpeningBalance: false,
         ItemOpeningBalance: false,
         ActionOnNegativeStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
         ActionOnMinimumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
         ActionOnMaximumStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
         ActionOnReorderStock: 0, // enum: ignore = 0, warn = 1, confirm = 2, block = 3
      });
      setErrors({});
   });

   const handleOnClose = useCallback(() => {
      clearFormData();
      onClose();
   }, [clearFormData, onClose]);

   useEffect(() => {
      if (!isOpen) return;

      const handleEscKey = (event) => {
         // Only handle ESC if no info modals are open
         if (isEmailInfoOpen || isPassKeyInfoOpen) return;

         if (event.key === 'Escape' || event.keyCode === 27) {
            event.preventDefault();
            event.stopPropagation();
            handleOnClose();
         }
      };

      // Use capture phase to intercept before Chakra UI
      window.addEventListener('keydown', handleEscKey, true);

      return () => {
         window.removeEventListener('keydown', handleEscKey, true);
      };
   }, [isOpen, isEmailInfoOpen, isPassKeyInfoOpen, handleOnClose]);

   const handleInputChange = (field, value) => {
      setRow((prev) => ({ ...prev, [field]: value }));
      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const handleSwitchChange = (field) => (event) => {
      setRow((prev) => ({
         ...prev,
         [field]: event.target.checked, // Updates boolean value (true/false)
      }));
   };

   const handlePrevious = () => {
      if (activeStep > 0) {
         setActiveStep(activeStep - 1);
      }
   };

   const onFormSubmit = async () => {
      try {
         const processedData = {
            ...row,
            isSync: row.isSync || false,
            syncCode: row.syncCode || '',
            syncDaybookId: row.syncDaybookId || null,
            notifyCustomTemp: row.notifyCustomTemp || '',
         };

         delete processedData.warehouse;
         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            await dispatch(updateCompanySetting(processedData));
         }
         onClose();
         await dispatch(getCompanies());
         setActiveStep(0);
         clearFormData();
         // window.location.reload();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleSave = async () => {
      onFormSubmit();
   };

   const handleNext = async () => {
      // const isValid = await validateStep();
      // if (isValid) {
      if (activeStep < steps.length - 1) {
         setActiveStep(activeStep + 1);
      } else {
         onFormSubmit();
      }
      // } else {
      //   toast({
      //     title: 'Validation Error',
      //     description: 'Please correct the errors.',
      //     status: 'error',
      //     duration: 3000,
      //     isClosable: true,
      //   });
      // }
   };

   const getCompanyDetailsByGST = useCallback(
      async (gst) => {
         if (isOpen) {
            dispatch(getCompanyDetailsByGst(gst));
         }
      },
      [dispatch],
   );

   useEffect(() => {
      if (gstNo) {
         getCompanyDetailsByGST(gstNo);
      }
   }, [getCompanyDetailsByGST, gstNo]);

   useEffect(() => {
      localStorage.setItem('showPrevTaxes', JSON.stringify(showPrevTaxes));
   }, [showPrevTaxes]);

   useEffect(() => {
      if (company) {
         const address = company && company.pradr ? company.pradr.addr : {};
         setRow((prev) => ({
            ...prev,
            name: company?.tradeNam,
            gstRegNo: gstNo,
            address1: `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`,
            cityId: cityList.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase())?.id,
            pincode: address?.pncd,
            panNo: gstNo?.slice(2, 12),
         }));
      }
   }, [cityList, company, gstNo]);
   useEffect(() => {
      if (isOpen) {
         dispatch(getUnit());
         dispatch(getHsn());
         dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(getItemGroup({ ...(shouldSendCompanyidItemGroup && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(getMainAndSubHsn());
         if (user && user?.loginhistory?.companyId)
            dispatch(
               getDaybook({
                  companyId: user?.loginhistory?.companyId,
                  ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
      }
   }, [dispatch, isOpen, user]);

   useEffect(() => {
      if (isOpen && isEditMode && currentRow) {
         const setting = currentRow?.setting;
         const settingData = {
            //gst fields
            applyGST: setting?.applyGST,
            GSTApplyDate:
               setting && setting?.GSTApplyDate
                  ? new Date(setting?.GSTApplyDate?.split(' ')[0]).toISOString().split('T')[0]
                  : new Date('2017-07-01').toISOString().split('T')[0],
            defaultHSN: setting?.defaultHSN || null,
            defaultSAC: setting?.defaultSAC || null,
            prevYearTurnover: setting?.prevYearTurnover || 0,
            eWayUserName: setting?.eWayUserName || '',
            url_custom: setting?.url_custom || '',
            authToken_custom: setting?.authToken_custom || '',
            accessKey_custom: setting?.accessKey_custom || '',
            instantId_custom: setting?.instantId_custom || '',
            eWayPassword: setting?.eWayPassword || '',
            eInvoiceUserName: setting?.eInvoiceUserName || '',
            eInvoicePassword: setting?.eInvoicePassword || '',
            isSync: setting?.isSync || false,
            syncCode: setting?.syncCode || '',
            syncDaybookId: setting?.syncDaybookId || null,
            whatsAppFrom: setting?.whatsAppFrom || 0,
            eWayLoginUID: setting?.eWayLoginUID || null,
            eWayLoginPWD: setting?.eWayLoginPWD || null,
            GSTNLoginUID: setting?.GSTNLoginUID || null,
            GSTNLoginPWD: setting?.GSTNLoginPWD || null,
            eInvoiceLoginUID: setting?.eInvoiceLoginUID || null,
            eInvoiceLoginPWD: setting?.eInvoiceLoginPWD || null,
            passKey: setting?.passKey || '',
            invReciptEmail: setting?.invReciptEmail || '',

            // order / challan
            enablePurchaseOrder: setting?.enablePurchaseOrder,
            partynoequaltodocno: setting?.partynoequaltodocno,
            ewayInvoice: setting?.ewayInvoice,
            ewayBill: setting?.ewayBill,
            cstTinno: setting?.cstTinno,
            vatRegNo: setting?.vatRegNo,
            csalesTaxNo: setting?.csalesTaxNo,
            iSalesTaxno: setting?.iSalesTaxno,
            enablePurchaseChallan: setting?.enablePurchaseChallan,
            enableSaleOrder: setting?.enableSaleOrder,
            enableSaleChallan: setting?.enableSaleChallan,

            // item
            priceLevel: setting?.priceLevel,
            priceMatrix: setting?.priceMatrix,
            warehouseWishStock: setting?.warehouseWishStock,
            warehouseInSale: setting?.warehouseInSale,
            warehouseInPurchase: setting?.warehouseInPurchase,
            warehouseInInventory: setting?.warehouseInInventory,
            maxUOM: setting?.maxUOM,
            UOM1: setting?.UOM1,
            UOM2: setting?.UOM2,
            UOM3: setting?.UOM3,
            primaryUnit: setting?.primaryUnit,
            itemType: setting?.itemType,
            itemDetailType: setting?.itemDetailType,
            notifyCustomTemp: setting?.notifyCustomTemp,
            itemGroupId: setting?.itemGroupId > 0 ? setting.itemGroupId : getDefaultId(itemGroupData, 'DEFAULT'),
            warehouseId: setting?.warehouseId > 0 ? setting.warehouseId : getDefaultId(warehouse, 'DEFAULT'),

            // Credit limit
            enableCreditLimit: setting?.enableCreditLimit,
            enableMultiCompanyCreditLimit: setting?.enableMultiCompanyCreditLimit,
            enableCreditLimitInDays: setting?.enableCreditLimitInDays,
            customerCreditAmount: setting?.customerCreditAmount || 0,
            customerCreditLimitAction: setting?.customerCreditLimitAction,
            vendorCreditAmount: setting?.vendorCreditAmount || 0,
            vendorCreditLimitAction: setting?.vendorCreditLimitAction,

            // Alert
            negativeCashAlert: setting?.negativeCashAlert,
            negativeStockAlert: setting?.negativeStockAlert,
            AccountOpeningBalance: setting?.AccountOpeningBalance,
            ItemOpeningBalance: setting?.ItemOpeningBalance,
            ActionOnNegativeStock: setting?.ActionOnNegativeStock,
            ActionOnMinimumStock: setting?.ActionOnMinimumStock,
            ActionOnMaximumStock: setting?.ActionOnMaximumStock,
            ActionOnReorderStock: setting?.ActionOnReorderStock,
         };

         setRow(settingData);
      }
   }, [currentRow, getDefaultId, isEditMode, isOpen, itemGroupData, warehouse]);

   const handleMessageFormatChange = (value) => {
      setMessageFormat(value);
      setRow((prev) => ({ ...prev, notifyCustomTemp: value }));
   };

   const handleFocusMove = (e, nextRef, prevRef) => {
      if (e.key === 'Tab' || e.key === 'Enter') {
         e.preventDefault(); // Prevent default tab/enter behavior
         if (e.shiftKey) {
            // Move to previous input if Shift is pressed
            prevRef?.current?.focus();
         } else {
            // Move to next input
            nextRef?.current?.focus();
         }
      }
   };

   const applyGSTRef = useRef(null);
   const gstRegNoRef = useRef(null);
   const showPrevTaxesRef = useRef(null);
   const gstRegDateRef = useRef(null);
   const defaultHSNRef = useRef(null);
   const defaultSACRef = useRef(null);
   const eWayUserNameRef = useRef(null);
   const whatsAppFromRef = useRef(null);
   const url_customRef = useRef(null);
   const accessKey_customRef = useRef(null);
   const instantId_customRef = useRef(null);
   const eWayPasswordRef = useRef(null);
   const eInvoiceUserNameRef = useRef(null);
   const eInvoicePasswordRef = useRef(null);
   const GSTNLoginUIDRef = useRef(null);
   const GSTNLoginPWDRef = useRef(null);
   const ewayBillRef = useRef(null);
   const ewayInvoiceRef = useRef(null);
   const iSalesTaxnoRef = useRef(null);
   const csalesTaxNoRef = useRef(null);
   const vatRegNoRef = useRef(null);
   const cstTinnoRef = useRef(null);
   const invReciptEmailRef = useRef(null);
   const passKeyRef = useRef(null);
   const SaveRef = useRef(null);

   useEffect(() => {
      setTimeout(() => {
         applyGSTRef.current?.focus();
      }, 100);
   }, [isOpen]);

   const insertKeyIntoMessage = (key) => {
      const textarea = textareaRef.current;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const textBefore = messageFormat.substring(0, start);
      const textAfter = messageFormat.substring(end);
      const newText = textBefore + `{${key}}` + textAfter;

      handleMessageFormatChange(newText);

      setTimeout(() => {
         textarea.focus();
         const newPosition = start + key.length + 2;
         textarea.setSelectionRange(newPosition, newPosition);
      }, 0);
   };

   const getHighlightedText = (text) => {
      if (!text) return '';

      // Replace variables with colored spans
      return text.replace(
         /\{([^}]+)\}/g,
         '<mark class="bg-blue-100 text-blue-700 font-semibold px-1 rounded">&#123;$1&#125;</mark>',
      );
   };

   const formatPreviewMessage = (template) => {
      return template
         .replace(/{itemName}/g, 'Sample Item')
         .replace(/{customerName}/g, 'John Doe')
         .replace(/{companyName}/g, 'ABC Company');
   };

   const renderColoredText = (text) => {
      if (!text) return null;

      const parts = text.split(/(\{[^}]+\})/g);
      return parts.map((part, index) => {
         if (part.match(/\{[^}]+\}/)) {
            return (
               <span key={index} style={{ color: '#2563eb', fontWeight: '600' }}>
                  {part}
               </span>
            );
         }
         return <span key={index}>{part}</span>;
      });
   };

   const handleScroll = () => {
      if (highlightRef.current && textareaRef.current) {
         highlightRef.current.scrollTop = textareaRef.current.scrollTop;
         highlightRef.current.scrollLeft = textareaRef.current.scrollLeft;
      }
   };

   const extractVariablesFromMessage = (text) => {
      const matches = text.match(/\{([^}]+)\}/g);
      return matches ? matches.map((m) => m.slice(1, -1)) : [];
   };

   const handleWhatsAppTypeChange = (value) => {
      handleInputChange('whatsAppFrom', value);

      if (value === 2) {
         onOpenQrCode();
      }
   };

   const handleWpEmailAutoTypeChange = (value) => {
      handleInputChange('reportFrequency', value);
   };

   const insertDemoFormat = (format) => {
      handleMessageFormatChange(format);
      setTimeout(() => {
         if (textareaRef.current) {
            textareaRef.current.scrollTop = 0;
         }
      }, 0);
   };

   return (
      <>
         <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" closeOnEsc={true} closeOnOverlayClick={false}>
            <ModalOverlay className="bg-black/60 backdrop-blur-sm" />
            <ModalContent
               className={`
      ${isDark ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'} 
      rounded-2xl p-0 shadow-2xl max-h-[90vh] border
    `}
               style={{
                  maxHeight: '90vh',
                  display: 'flex',
                  flexDirection: 'column',
               }}>
               {/* Beautiful Header with Gradient */}

               <ModalHeader
                  className={`relative overflow-hidden ${
                     isDark
                        ? 'bg-gradient-to-r from-blue-900/80 via-purple-900/80 to-indigo-900/80 border-b border-blue-700/50'
                        : 'bg-gradient-to-r from-blue-50 via-purple-50 to-indigo-50 border-b border-blue-200'
                  }`}
                  fontSize="24px"
                  fontWeight="800"
                  py={6}
                  px={8}
                  style={{ flexShrink: 0 }}>
                  <div className="flex items-center gap-3">
                     <div
                        className={`p-2 rounded-xl ${
                           isDark ? 'bg-blue-600/20 border border-blue-500/30' : 'bg-blue-100 border border-blue-200'
                        }`}>
                        {isEditMode ? '✏️' : '✨'}
                     </div>
                     <span
                        className={`bg-gradient-to-r ${
                           isDark ? 'from-blue-200 to-purple-200' : 'from-blue-600 to-purple-600'
                        } bg-clip-text text-transparent`}>
                        {isEditMode ? 'Edit Company' : 'Add New Company'}
                     </span>
                  </div>
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-cyan-500"></div>
               </ModalHeader>
               <ModalCloseButton
                  className={`absolute top-4 right-6 ${
                     isDark
                        ? 'text-gray-300 hover:text-white hover:bg-red-600/20 border border-gray-600'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-red-100 border border-gray-300'
                  } transition-all duration-200 rounded-xl w-8 h-8`}
                  _focus={{ boxShadow: 'none' }}
               />

               <ModalBody
                  className="p-6 overflow-y-auto"
                  style={{
                     flex: 1,
                     overflowY: 'auto',
                     minHeight: 0,
                  }}>
                  {/* Enhanced Stepper */}
                  <div
                     className={`
        ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-gray-50 border-gray-300'} 
        rounded-xl p-5 mb-6 shadow-sm border-2
      `}>
                     <div className="flex items-center justify-between">
                        {steps.map((step, index) => (
                           <div key={index} className="flex items-center flex-1">
                              <div className="flex flex-col items-center flex-1">
                                 <button
                                    onClick={() => setActiveStep(index)}
                                    className={`transition-all duration-300 hover:scale-105 ${
                                       activeStep === index ? 'transform scale-110' : ''
                                    }`}>
                                    <div
                                       className={`
                    w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all duration-300
                    ${
                       activeStep === index
                          ? isDark
                             ? 'bg-purple-600 border-purple-500'
                             : 'bg-blue-500 border-blue-400'
                          : isDark
                          ? 'border-gray-500'
                          : 'border-gray-400'
                    }
                    ${
                       activeStep > index
                          ? isDark
                             ? 'bg-green-600 border-green-500'
                             : 'bg-green-500 border-green-400'
                          : ''
                    }
                  `}>
                                       {activeStep > index ? (
                                          <span className="text-white">✓</span>
                                       ) : (
                                          <span
                                             className={`
                        ${activeStep === index ? 'text-white' : isDark ? 'text-gray-300' : 'text-gray-600'}
                      `}>
                                             {index + 1}
                                          </span>
                                       )}
                                    </div>
                                 </button>
                                 <span
                                    className={`
                  text-xs font-semibold mt-2 text-center
                  ${isDark ? 'text-gray-300' : 'text-gray-700'}
                `}>
                                    {step.title}
                                 </span>
                              </div>
                              {index < steps.length - 1 && (
                                 <div
                                    className={`
                  flex-1 h-0.5 mx-4
                  ${isDark ? 'bg-gray-600' : 'bg-gray-300'}
                `}
                                 />
                              )}
                           </div>
                        ))}
                     </div>
                  </div>

                  {/* Content Sections with Beautiful Cards */}
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                     {activeStep === 0 && (
                        <>
                           {/* GST Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    🏢 GST Configuration
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'applyGST',
                                          'Apply GST',
                                          {
                                             isChecked: row.applyGST,
                                             onChange: handleSwitchChange('applyGST'),
                                             ref: applyGSTRef,
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   row.applyGST ? gstRegDateRef : showPrevTaxesRef,
                                                   null,
                                                ),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    {row.applyGST && (
                                       <>
                                          <div>
                                             {DynamicInput(
                                                'GSTApplyDate',
                                                'GST Reg Date',
                                                {
                                                   value: row.GSTApplyDate,
                                                   onChange: (e) => handleInputChange('GSTApplyDate', e.target.value),
                                                   ref: gstRegDateRef,
                                                   onKeyDown: (e) => handleFocusMove(e, defaultHSNRef, applyGSTRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'date',
                                                false,
                                             )}
                                          </div>

                                          <div className="z-30">
                                             {renderDynamicDropdown(
                                                'defaultHSN',
                                                'Default HSN',
                                                hsnData?.map((item) => ({
                                                   id: item.id,
                                                   name: item.hsn,
                                                })),
                                                {
                                                   value: row.defaultHSN,
                                                   onChange: (value) => handleInputChange('defaultHSN', value),
                                                   ref: defaultHSNRef,
                                                   onKeyDown: (e) => handleFocusMove(e, defaultSACRef, gstRegDateRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                false,
                                                'Select HSN',
                                             )}
                                          </div>

                                          <div>
                                             {renderDynamicDropdown(
                                                'defaultSAC',
                                                'Default SAC',
                                                sacData?.map((item) => ({
                                                   id: item.id,
                                                   name: item.hsn,
                                                })),
                                                {
                                                   value: row.defaultSAC,
                                                   onChange: (value) => handleInputChange('defaultSAC', value),
                                                   ref: defaultSACRef,
                                                   onKeyDown: (e) => handleFocusMove(e, eWayUserNameRef, defaultHSNRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                false,
                                                'Select SAC',
                                             )}
                                          </div>

                                          <div>
                                             {DynamicInput(
                                                'eWayUserName',
                                                'E-way Bill user',
                                                {
                                                   value: row.eWayUserName,
                                                   onChange: (e) => handleInputChange('eWayUserName', e.target.value),
                                                   ref: eWayUserNameRef,
                                                   onKeyDown: (e) => handleFocusMove(e, eWayPasswordRef, defaultSACRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {DynamicInput(
                                                'eWayPassword',
                                                'E-way Bill Password',
                                                {
                                                   value: row.eWayPassword,
                                                   onChange: (e) => handleInputChange('eWayPassword', e.target.value),
                                                   ref: eWayPasswordRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(e, eInvoiceUserNameRef, eWayUserNameRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {DynamicInput(
                                                'eInvoiceUserName',
                                                'E invoice user',
                                                {
                                                   value: row.eInvoiceUserName,
                                                   onChange: (e) =>
                                                      handleInputChange('eInvoiceUserName', e.target.value),
                                                   ref: eInvoiceUserNameRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(e, eInvoicePasswordRef, eWayPasswordRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {DynamicInput(
                                                'eInvoicePassword',
                                                'E invoice Password',
                                                {
                                                   value: row.eInvoicePassword,
                                                   onChange: (e) =>
                                                      handleInputChange('eInvoicePassword', e.target.value),
                                                   ref: eInvoicePasswordRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(e, GSTNLoginUIDRef, eInvoiceUserNameRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {DynamicInput(
                                                'GSTNLoginUID',
                                                'GST User Name',
                                                {
                                                   value: row.GSTNLoginUID,
                                                   onChange: (e) => handleInputChange('GSTNLoginUID', e.target.value),
                                                   ref: GSTNLoginUIDRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(e, GSTNLoginPWDRef, eInvoicePasswordRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {DynamicInput(
                                                'GSTNLoginPWD',
                                                'GST User Password',
                                                {
                                                   value: row.GSTNLoginPWD,
                                                   onChange: (e) => handleInputChange('GSTNLoginPWD', e.target.value),
                                                   ref: GSTNLoginPWDRef,
                                                   onKeyDown: (e) => handleFocusMove(e, ewayBillRef, GSTNLoginUIDRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {renderSwitchControl(
                                                'ewayBill',
                                                'E-way Bill',
                                                {
                                                   isChecked: row.ewayBill,
                                                   onChange: handleSwitchChange('ewayBill'),
                                                   ref: ewayBillRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(e, ewayInvoiceRef, GSTNLoginPWDRef),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {renderSwitchControl(
                                                'ewayInvoice',
                                                'E-Invoice',
                                                {
                                                   isChecked: row.ewayInvoice,
                                                   onChange: handleSwitchChange('ewayInvoice'),
                                                   ref: ewayInvoiceRef,
                                                   onKeyDown: (e) => handleFocusMove(e, showPrevTaxesRef, ewayBillRef),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>
                                       </>
                                    )}
                                 </div>
                              </div>
                           </div>

                           {/* Previous Taxes Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    📋 Previous Taxes
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'showPrevTaxes',
                                          'ADD PREV. TAXES',
                                          {
                                             isChecked: showPrevTaxes,
                                             onChange: (e) => setShowPrevTaxes(e.target.checked),
                                             ref: showPrevTaxesRef,
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   showPrevTaxes ? iSalesTaxnoRef : invReciptEmailRef,
                                                   row.applyGST ? ewayInvoiceRef : applyGSTRef,
                                                ),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    {showPrevTaxes && (
                                       <>
                                          <div>
                                             {renderSwitchControl(
                                                'iSalesTaxno',
                                                'I Sales TaxNo',
                                                {
                                                   isChecked: row.iSalesTaxno,
                                                   onChange: handleSwitchChange('iSalesTaxno'),
                                                   ref: iSalesTaxnoRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(e, csalesTaxNoRef, showPrevTaxesRef),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {renderSwitchControl(
                                                'csalesTaxNo',
                                                'CSales Tax No',
                                                {
                                                   isChecked: row.csalesTaxNo,
                                                   onChange: handleSwitchChange('csalesTaxNo'),
                                                   ref: csalesTaxNoRef,
                                                   onKeyDown: (e) => handleFocusMove(e, vatRegNoRef, iSalesTaxnoRef),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {renderSwitchControl(
                                                'vatRegNo',
                                                'Vat Reg No',
                                                {
                                                   isChecked: row.vatRegNo,
                                                   onChange: handleSwitchChange('vatRegNo'),
                                                   ref: vatRegNoRef,
                                                   onKeyDown: (e) => handleFocusMove(e, cstTinnoRef, csalesTaxNoRef),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {renderSwitchControl(
                                                'cstTinno',
                                                'CstTin no',
                                                {
                                                   isChecked: row.cstTinno,
                                                   onChange: handleSwitchChange('cstTinno'),
                                                   ref: cstTinnoRef,
                                                   onKeyDown: (e) => handleFocusMove(e, invReciptEmailRef, vatRegNoRef),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>
                                       </>
                                    )}
                                 </div>
                              </div>
                           </div>

                           {/* Email Configuration Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    📧 Email Configuration
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                       <div className="flex items-center gap-2">
                                          <div className="flex-1">
                                             {DynamicInput(
                                                'invReciptEmail',
                                                'Email',
                                                {
                                                   value: row.invReciptEmail,
                                                   onChange: (e) => handleInputChange('invReciptEmail', e.target.value),
                                                   ref: invReciptEmailRef,
                                                   onKeyDown: (e) =>
                                                      handleFocusMove(
                                                         e,
                                                         passKeyRef,
                                                         showPrevTaxes ? cstTinnoRef : showPrevTaxesRef,
                                                      ),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'email',
                                                false,
                                             )}
                                          </div>
                                          <button
                                             onClick={() => setIsEmailInfoOpen(true)}
                                             className={`
                          p-2 rounded-lg transition-colors
                          ${isDark ? 'hover:bg-purple-900 text-purple-400' : 'hover:bg-purple-100 text-purple-600'}
                        `}>
                                             <FaInfo />
                                          </button>
                                       </div>
                                    </div>

                                    <div>
                                       <div className="flex items-center gap-2">
                                          <div className="flex-1">
                                             {DynamicInput(
                                                'passKey',
                                                'Pass Key',
                                                {
                                                   value: row.passKey,
                                                   onChange: (e) => handleInputChange('passKey', e.target.value),
                                                   ref: passKeyRef,
                                                   onKeyDown: (e) => handleFocusMove(e, SaveRef, invReciptEmailRef),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>
                                          <button
                                             onClick={() => setIsPassKeyInfoOpen(true)}
                                             className={`
                          p-2 rounded-lg transition-colors
                          ${isDark ? 'hover:bg-purple-900 text-purple-400' : 'hover:bg-purple-100 text-purple-600'}
                        `}>
                                             <FaInfo />
                                          </button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </>
                     )}

                     {activeStep === 1 && (
                        <>
                           {/* Business Settings Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    ⚙️ Business Settings
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'partyNoEqualToDocno',
                                          'Party Bill No Equal To Doc No',
                                          {
                                             isChecked: row.partynoequaltodocno,
                                             onChange: handleSwitchChange('partynoequaltodocno'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>
                                    <div>
                                       {renderSwitchControl(
                                          'enablePurchaseOrder',
                                          'Enable Purchase Order',
                                          {
                                             isChecked: row.enablePurchaseOrder,
                                             onChange: handleSwitchChange('enablePurchaseOrder'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>
                                    <div>
                                       {renderSwitchControl(
                                          'enablePurchaseChallan',
                                          'Enable Purchase Challan',
                                          {
                                             isChecked: row.enablePurchaseChallan,
                                             onChange: handleSwitchChange('enablePurchaseChallan'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>
                                    <div>
                                       {renderSwitchControl(
                                          'enableSaleOrder',
                                          'Enable Sale Order',
                                          {
                                             isChecked: row.enableSaleOrder,
                                             onChange: handleSwitchChange('enableSaleOrder'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>
                                    <div>
                                       {renderSwitchControl(
                                          'enableSaleChallan',
                                          'Enable Sale Challan',
                                          {
                                             isChecked: row.enableSaleChallan,
                                             onChange: handleSwitchChange('enableSaleChallan'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {/* Warehouse Management Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    🏭 Warehouse Management
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'warehouseWishStock',
                                          'Warehouse Wish Stock',
                                          {
                                             isChecked: row.warehouseWishStock,
                                             onChange: handleSwitchChange('warehouseWishStock'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    {row.warehouseWishStock && (
                                       <>
                                          <div>
                                             {renderDynamicDropdown(
                                                'warehouseId',
                                                'Warehouse',
                                                warehouse,
                                                {
                                                   value: row.warehouseId,
                                                   onChange: (value) => handleInputChange('warehouseId', value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                false,
                                                'Select Warehouse',
                                             )}
                                          </div>

                                          <div>
                                             {renderDynamicDropdown(
                                                'warehouseInSale',
                                                'Warehouse In Sale',
                                                WAREHOUSE_TYPE,
                                                {
                                                   value: row.warehouseInSale,
                                                   onChange: (value) => handleInputChange('warehouseInSale', value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                false,
                                                'Select header',
                                             )}
                                          </div>

                                          <div>
                                             {renderDynamicDropdown(
                                                'warehouseInPurchase',
                                                'Warehouse In Purchase',
                                                WAREHOUSE_TYPE,
                                                {
                                                   value: row.warehouseInPurchase,
                                                   onChange: (value) => handleInputChange('warehouseInPurchase', value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                false,
                                                'Select header',
                                             )}
                                          </div>

                                          <div>
                                             {renderDynamicDropdown(
                                                'warehouseInInventory',
                                                'Warehouse In Inventory',
                                                WAREHOUSE_TYPE,
                                                {
                                                   value: row.warehouseInInventory,
                                                   onChange: (value) =>
                                                      handleInputChange('warehouseInInventory', value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                false,
                                                'Select header',
                                             )}
                                          </div>
                                       </>
                                    )}
                                 </div>
                              </div>
                           </div>

                           {/* Credit Limit Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    💳 Credit Limit Configuration
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'enableCreditLimit',
                                          'Enable Credit Limit',
                                          {
                                             isChecked: row.enableCreditLimit,
                                             onChange: handleSwitchChange('enableCreditLimit'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    {row.enableCreditLimit && (
                                       <>
                                          <div>
                                             {renderSwitchControl(
                                                'enableMultiCompanyCreditLimit',
                                                'Enable Multi Company Credit Limit',
                                                {
                                                   isChecked: row.enableMultiCompanyCreditLimit,
                                                   onChange: handleSwitchChange('enableMultiCompanyCreditLimit'),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>

                                          <div>
                                             {renderSwitchControl(
                                                'enableCreditLimitInDays',
                                                'Enable Credit Limit In Days',
                                                {
                                                   isChecked: row.enableCreditLimitInDays,
                                                   onChange: handleSwitchChange('enableCreditLimitInDays'),
                                                },
                                                errors,
                                                isDark ? 'gray.300' : 'gray.700',
                                                false,
                                                false,
                                             )}
                                          </div>
                                          <div>
                                             {DynamicInput(
                                                'customerCreditAmount',
                                                'Customer Credit Amount',
                                                {
                                                   value: row.customerCreditAmount,
                                                   onChange: (e) =>
                                                      handleInputChange('customerCreditAmount', e.target.value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'number',
                                                false,
                                             )}
                                          </div>
                                          <div>
                                             {renderDynamicDropdown(
                                                'customerCreditLimitAction',
                                                'Customer Credit Limit Action',
                                                ACTION_TYPE,
                                                {
                                                   value: row.customerCreditLimitAction,
                                                   onChange: (value) =>
                                                      handleInputChange('customerCreditLimitAction', value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                true,
                                                'Select Action',
                                             )}
                                          </div>
                                          <div>
                                             {DynamicInput(
                                                'vendorCreditAmount',
                                                'Vendor Credit Amount',
                                                {
                                                   value: row.vendorCreditAmount,
                                                   onChange: (e) =>
                                                      handleInputChange('vendorCreditAmount', e.target.value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'number',
                                                false,
                                             )}
                                          </div>
                                          <div>
                                             {renderDynamicDropdown(
                                                'vendorCreditLimitAction',
                                                'Vendor Credit Limit Action',
                                                ACTION_TYPE,
                                                {
                                                   value: row.vendorCreditLimitAction,
                                                   onChange: (value) =>
                                                      handleInputChange('vendorCreditLimitAction', value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                true,
                                                'Select Action',
                                             )}
                                          </div>
                                       </>
                                    )}
                                 </div>
                              </div>
                           </div>

                           {/* Alerts & Stock Management Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    🚨 Alerts & Stock Management
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'negativeCashAlert',
                                          'Negative Cash Alert',
                                          {
                                             isChecked: row.negativeCashAlert,
                                             onChange: handleSwitchChange('negativeCashAlert'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    <div>
                                       {renderSwitchControl(
                                          'negativeStockAlert',
                                          'Negative Stock Alert',
                                          {
                                             isChecked: row.negativeStockAlert,
                                             onChange: handleSwitchChange('negativeStockAlert'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'ActionOnNegativeStock',
                                          'Action On Negative Stock',
                                          ACTION_TYPE,
                                          {
                                             value: row.ActionOnNegativeStock,
                                             onChange: (value) => handleInputChange('ActionOnNegativeStock', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          true,
                                          'Select Action',
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'ActionOnMinimumStock',
                                          'Action On Minimum Stock',
                                          ACTION_TYPE,
                                          {
                                             value: row.ActionOnMinimumStock,
                                             onChange: (value) => handleInputChange('ActionOnMinimumStock', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          true,
                                          'Select Action',
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'ActionOnMaximumStock',
                                          'Action On Maximum Stock',
                                          ACTION_TYPE,
                                          {
                                             value: row.ActionOnMaximumStock,
                                             onChange: (value) => handleInputChange('ActionOnMaximumStock', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          true,
                                          'Select Action',
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'ActionOnReorderStock',
                                          'Action On Reorder Stock',
                                          ACTION_TYPE,
                                          {
                                             value: row.ActionOnReorderStock,
                                             onChange: (value) => handleInputChange('ActionOnReorderStock', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          true,
                                          'Select Action',
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {/* Sync Configuration Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    🔄 Sync Configuration
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'isSync',
                                          'Sync',
                                          {
                                             isChecked: row.isSync,
                                             onChange: handleSwitchChange('isSync'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    <div>
                                       {DynamicInput(
                                          'syncCode',
                                          'Sync Code',
                                          {
                                             value: row.syncCode,
                                             onChange: (e) => handleInputChange('syncCode', e.target.value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          'text',
                                          false,
                                          true,
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'syncDaybookId',
                                          'Sync Daybook',
                                          daybook,
                                          {
                                             value: row.syncDaybookId,
                                             onChange: (value) => handleInputChange('syncDaybookId', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select SAC',
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {/* Sync Configuration Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    💬 WhatsApp setting
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div className="flex gap-1">
                                       {renderDynamicDropdown(
                                          'whatsAppFrom',
                                          'Send WhatsApp Type',
                                          WhatsAppType,
                                          {
                                             value: row.whatsAppFrom,
                                             onChange: handleWhatsAppTypeChange,
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select WhatsApp Type',
                                       )}
                                       {row.whatsAppFrom === 2 && (
                                          <div className="col-span-1 flex items-center justify-center">
                                             <button
                                                onClick={onOpenQrCode}
                                                className={`
                     px-3 py-2 rounded-lg transition-all duration-300 hover:scale-105
                     ${
                        isDark
                           ? 'bg-gradient-to-r from-purple-700 to-purple-600 hover:from-purple-600 hover:to-purple-500 text-white border border-purple-500'
                           : 'bg-gradient-to-r from-purple-500 to-purple-400 hover:from-purple-600 hover:to-purple-500 text-white border border-purple-300'
                     }
                     flex items-center gap-2 font-medium shadow-md
                  `}
                                                title="Scan QR Code for WhatsApp">
                                                <svg
                                                   xmlns="http://www.w3.org/2000/svg"
                                                   className="h-5 w-5"
                                                   viewBox="0 0 20 20"
                                                   fill="currentColor">
                                                   <path
                                                      fillRule="evenodd"
                                                      d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z"
                                                      clipRule="evenodd"
                                                   />
                                                   <path d="M11 4a1 1 0 10-2 0v1a1 1 0 102 0V4zM10 7a1 1 0 011 1v1h1a1 1 0 110 2h-2a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" />
                                                </svg>
                                             </button>
                                          </div>
                                       )}
                                    </div>

                                    {/* {row.whatsAppFrom === 1 && (
                                       <>
                                          <div>
                                             {DynamicInput(
                                                'url_custom',
                                                'Custom url for whatsapp',
                                                {
                                                   value: row.url_custom,
                                                   onChange: (e) => handleInputChange('url_custom', e.target.value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>
                                          <div>
                                             {DynamicInput(
                                                'accessKey_custom',
                                                'Accesskey for whatsapp',
                                                {
                                                   value: row.accessKey_custom,
                                                   onChange: (e) => handleInputChange('accessKey_custom', e.target.value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>
                                          <div>
                                             {DynamicInput(
                                                'instantId_custom',
                                                'Custom instant',
                                                {
                                                   value: row.instantId_custom,
                                                   onChange: (e) => handleInputChange('instantId_custom', e.target.value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>
                                       </>
                                    )} */}
                                    {row.whatsAppFrom === 1 && (
                                       <>
                                          <div>
                                             {DynamicInput(
                                                'authToken_custom',
                                                '11za Custom authToken for whatsapp',
                                                {
                                                   value: row.authToken_custom,
                                                   onChange: (e) =>
                                                      handleInputChange('authToken_custom', e.target.value),
                                                },
                                                errors,
                                                isDark ? 'white' : 'gray.900',
                                                'text',
                                                false,
                                             )}
                                          </div>
                                       </>
                                    )}
                                    {/* {renderDynamicDropdown(
                                       'Report Frequency',
                                       'Report Frequency',
                                       ReportFrequencyType,
                                       {
                                          value: row.reportFrequency,
                                          onChange: handleWpEmailAutoTypeChange,
                                       },
                                       errors,
                                       isDark ? 'white' : 'gray.900',
                                       false,
                                       'Select Report Frequency',
                                    )}
                                    {row.reportFrequency === 1 &&
                                       renderDynamicDropdown(
                                          'reportDay',
                                          'Select Day',
                                          WeekDaysType,
                                          {
                                             value: row.reportDay,
                                             onChange: (value) => handleInputChange('reportDay', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select Day',
                                       )} */}
                                 </div>
                              </div>
                           </div>
                        </>
                     )}

                     {activeStep === 2 && (
                        <>
                           {/* Pricing Configuration Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    💰 Pricing Configuration
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderSwitchControl(
                                          'priceLevel',
                                          'Price Level',
                                          {
                                             isChecked: row.priceLevel,
                                             onChange: handleSwitchChange('priceLevel'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>

                                    <div>
                                       {renderSwitchControl(
                                          'priceMatrix',
                                          'Price Matrix',
                                          {
                                             isChecked: row.priceMatrix,
                                             onChange: handleSwitchChange('priceMatrix'),
                                          },
                                          errors,
                                          isDark ? 'gray.300' : 'gray.700',
                                          false,
                                          false,
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {/* UOM Configuration Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 mb-2 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    📏 Unit of Measurement (UOM)
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {DynamicInput(
                                          'maxUOM',
                                          'Max UOM',
                                          {
                                             value: row.maxUOM,
                                             onChange: (e) => handleInputChange('maxUOM', e.target.value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          'number',
                                          false,
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'UOM1',
                                          'UOM 1',
                                          uqc,
                                          {
                                             value: row.UOM1,
                                             onChange: (value) => handleInputChange('UOM1', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select UOM 1',
                                       )}
                                    </div>

                                    {row.maxUOM > 1 && (
                                       <div>
                                          {renderDynamicDropdown(
                                             'UOM2',
                                             'UOM 2',
                                             uqc,
                                             {
                                                value: row.UOM2,
                                                onChange: (value) => handleInputChange('UOM2', value),
                                             },
                                             errors,
                                             isDark ? 'white' : 'gray.900',
                                             false,
                                             'Select UOM 2',
                                          )}
                                       </div>
                                    )}

                                    {row.maxUOM >= 3 && (
                                       <div>
                                          {renderDynamicDropdown(
                                             'UOM3',
                                             'UOM 3',
                                             uqc,
                                             {
                                                value: row.UOM3,
                                                onChange: (value) => handleInputChange('UOM3', value),
                                             },
                                             errors,
                                             isDark ? 'white' : 'gray.900',
                                             false,
                                             'Select UOM 3',
                                          )}
                                       </div>
                                    )}

                                    <div>
                                       {renderDynamicDropdown(
                                          'primaryUnit',
                                          'Primary Unit',
                                          uqc,
                                          {
                                             value: row.primaryUnit,
                                             onChange: (value) => handleInputChange('primaryUnit', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select Primary Unit',
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {/* Item Configuration Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`
                ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'} 
                rounded-xl p-4 border-2
              `}>
                                 <div
                                    className={`
                  text-lg font-bold mb-3 pb-2 border-b-2
                  ${isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'}
                `}>
                                    📦 Item Configuration
                                 </div>
                                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                    <div>
                                       {renderDynamicDropdown(
                                          'itemType',
                                          'Item Type',
                                          ITEM_TYPE,
                                          {
                                             value: row.itemType,
                                             onChange: (value) => handleInputChange('itemType', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select Item Type',
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'itemGroupId',
                                          'Item Group',
                                          itemGroupData,
                                          {
                                             value: row.itemGroupId,
                                             onChange: (value) => handleInputChange('itemGroupId', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select Item Group',
                                       )}
                                    </div>

                                    <div>
                                       {renderDynamicDropdown(
                                          'itemDetailType',
                                          'Item Details Type',
                                          ITEM_DETAILS_TYPES,
                                          {
                                             value: row.itemDetailType,
                                             onChange: (value) => handleInputChange('itemDetailType', value),
                                          },
                                          errors,
                                          isDark ? 'white' : 'gray.900',
                                          false,
                                          'Select Item Details Types',
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {/* Message Format Section */}
                           <div className="col-span-1 md:col-span-2 xl:col-span-3">
                              <div
                                 className={`${
                                    isDark ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-300'
                                 } rounded-xl p-6 border-2 shadow-lg`}>
                                 <label
                                    className={`text-lg font-bold mb-3 pb-2 border-b-2 block ${
                                       isDark ? 'text-purple-400 border-gray-600' : 'text-blue-600 border-gray-300'
                                    }`}>
                                    💬 NotifyMe Message Format
                                 </label>

                                 {/* Demo Formats Section */}
                                 <div className="mb-4 p-4 bg-blue-50 border border-blue-100 rounded-lg">
                                    <div className="flex items-center gap-2 mb-3">
                                       <span className="text-sm font-medium text-blue-700">📋 Demo Formats:</span>
                                       <span className="text-xs text-blue-600">
                                          (Click to insert - clears existing text)
                                       </span>
                                    </div>

                                    <div className="flex flex-wrap gap-2">
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                'Your item {itemName} has been processed successfully. Thank you for your purchase!',
                                             )
                                          }
                                          className="px-3 py-1.5 bg-blue-100 border border-blue-300 rounded-md cursor-pointer text-xs font-medium text-blue-800 transition-colors hover:bg-blue-200 flex-shrink-0">
                                          Item Format
                                       </button>

                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                'Dear {customerName}, thank you for your business. We appreciate you choosing {companyName}!',
                                             )
                                          }
                                          className="px-3 py-1.5 bg-green-100 border border-green-300 rounded-md cursor-pointer text-xs font-medium text-green-800 transition-colors hover:bg-green-200 flex-shrink-0">
                                          Customer Greeting
                                       </button>

                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                'Hello {customerName},\n\nYour order for {itemName} has been confirmed by {companyName}.\n\nThank you!',
                                             )
                                          }
                                          className="px-3 py-1.5 bg-yellow-100 border border-yellow-300 rounded-md cursor-pointer text-xs font-medium text-yellow-800 transition-colors hover:bg-yellow-200 flex-shrink-0">
                                          Order Confirmation
                                       </button>

                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                'Important announcement from {companyName} for our valued customer {customerName} regarding {itemName}.',
                                             )
                                          }
                                          className="px-3 py-1.5 bg-purple-100 border border-purple-300 rounded-md cursor-pointer text-xs font-medium text-purple-800 transition-colors hover:bg-purple-200 flex-shrink-0">
                                          Company Announcement
                                       </button>

                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat('{customerName} - {itemName} - {companyName}')
                                          }
                                          className="px-3 py-1.5 bg-pink-100 border border-pink-300 rounded-md cursor-pointer text-xs font-medium text-pink-800 transition-colors hover:bg-pink-200 flex-shrink-0">
                                          Simple Format
                                       </button>
                                    </div>
                                 </div>

                                 {/* Insert Keys Section */}
                                 <div className="mb-4 flex items-center flex-wrap gap-2">
                                    <span className="text-sm font-medium text-gray-600">Insert keys:</span>
                                    {['itemName', 'customerName', 'companyName'].map((key) => (
                                       <button
                                          key={key}
                                          type="button"
                                          onClick={() => insertKeyIntoMessage(key)}
                                          className="px-3 py-1.5 bg-gray-100 border border-gray-300 rounded-md cursor-pointer text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200 flex-shrink-0">
                                          {key}
                                       </button>
                                    ))}
                                 </div>

                                 {/* Textarea with Syntax Highlighting */}
                                 <div className="relative mb-4">
                                    {/* Highlighted backdrop */}
                                    <div
                                       ref={highlightRef}
                                       className={`absolute inset-0 p-3 text-sm leading-relaxed font-mono whitespace-pre-wrap break-words overflow-auto pointer-events-none border-2 border-transparent rounded-lg ${
                                          isDark ? 'text-gray-300' : 'text-gray-900'
                                       }`}
                                       style={{
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                       }}
                                       dangerouslySetInnerHTML={{
                                          __html: messageFormat
                                             ? getHighlightedText(messageFormat)
                                             : '<span class="text-gray-400">Type your message here. Click keys above to insert variables like {itemName}, {customerName}</span>',
                                       }}
                                    />

                                    {/* Actual textarea */}
                                    <textarea
                                       ref={textareaRef}
                                       value={messageFormat}
                                       onChange={(e) => handleMessageFormatChange(e.target.value)}
                                       onScroll={handleScroll}
                                       placeholder=""
                                       spellCheck={false}
                                       autoComplete="off"
                                       autoCorrect="off"
                                       autoCapitalize="off"
                                       rows={6}
                                       className={`relative w-full p-3 border-2 ${
                                          error ? 'border-red-500' : 'border-gray-300'
                                       } rounded-lg text-sm leading-relaxed font-mono resize-y bg-transparent caret-gray-900 focus:outline-none focus:border-blue-500 overflow-auto`}
                                       style={{
                                          color: 'transparent',
                                          WebkitTextFillColor: 'transparent',
                                          minHeight: '140px',
                                          maxHeight: '400px',
                                          caretColor: '#111827',
                                       }}
                                    />
                                 </div>

                                 {error && (
                                    <div className="mt-3 text-red-500 text-xs p-2 bg-red-50 border border-red-200 rounded-md">
                                       {error}
                                    </div>
                                 )}
                              </div>
                           </div>
                        </>
                     )}
                  </div>
               </ModalBody>

               {/* Enhanced Footer with Gradient */}
               <ModalFooter
                  className={`
      border-t-2 ${isDark ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50'}
      rounded-b-2xl p-5
    `}
                  style={{ flexShrink: 0 }}>
                  <div className="flex gap-3 w-full justify-end">
                     {activeStep > 0 && (
                        <button
                           onClick={handlePrevious}
                           className={`
              px-4 py-2 border-2 rounded-lg transition-all duration-300 hover:-translate-x-1
              ${
                 isDark
                    ? 'border-purple-500 text-purple-400 hover:bg-purple-900'
                    : 'border-purple-400 text-purple-600 hover:bg-purple-50'
              }
            `}>
                           ← Previous
                        </button>
                     )}
                     <button
                        onClick={handleNext}
                        className={`
            px-4 py-2 text-white rounded-lg transition-all duration-300 hover:translate-x-1
            ${
               isDark
                  ? 'bg-gradient-to-r from-purple-600 to-purple-500 hover:from-purple-700 hover:to-purple-600'
                  : 'bg-gradient-to-r from-purple-500 to-purple-400 hover:from-purple-600 hover:to-purple-500'
            }
          `}>
                        Next →
                     </button>
                     <button
                        onClick={handleSave}
                        ref={SaveRef}
                        className={`
            px-4 py-2 text-white rounded-lg transition-all duration-300 hover:scale-105 font-bold
            ${
               isDark
                  ? 'bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600'
                  : 'bg-gradient-to-r from-green-500 to-green-400 hover:from-green-600 hover:to-green-500'
            }
          `}>
                        ✓ Save
                     </button>
                     <button
                        onClick={handleOnClose}
                        className={`
            px-4 py-2 rounded-lg transition-colors
            ${isDark ? 'hover:bg-red-900 text-gray-300' : 'hover:bg-red-50 text-gray-600'}
          `}>
                        Cancel
                     </button>
                  </div>
               </ModalFooter>
            </ModalContent>
         </Modal>

         <Modal isOpen={isEmailInfoOpen} onClose={() => setIsEmailInfoOpen(false)} size="lg" closeOnEsc={true}>
            <ModalOverlay />
            <ModalContent className={isDark ? 'bg-gray-800' : 'bg-white'}>
               <ModalHeader className={isDark ? 'text-white' : 'text-gray-900'}>Custom Email Information</ModalHeader>
               <ModalCloseButton />
               <ModalBody className="pb-6">
                  <p className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                     Enter a custom email and its app-pass key to send invoices from your own address. If no custom
                     email is provided, invoices will be sent from the default system email.
                  </p>
               </ModalBody>
            </ModalContent>
         </Modal>

         {/* Pass Key Info Modal */}
         <Modal isOpen={isPassKeyInfoOpen} onClose={() => setIsPassKeyInfoOpen(false)} size="xl" closeOnEsc={true}>
            <ModalOverlay />
            <ModalContent className={isDark ? 'bg-gray-800' : 'bg-white'}>
               <ModalHeader className={isDark ? 'text-white' : 'text-gray-900'}>
                  How to Generate a Google App Password
               </ModalHeader>
               <ModalCloseButton />
               <ModalBody className="pb-6">
                  <p className={`font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>Follow these steps:</p>

                  <div className="mb-4">
                     <p className={`font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
                        1. Enable 2-Step Verification:
                     </p>
                     <ul className="list-disc ml-6 space-y-2">
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           Visit Google Account Security Settings:{' '}
                           <a
                              href="https://myaccount.google.com/security"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline">
                              https://myaccount.google.com/security
                           </a>
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           Under "Signing in to Google," click on <strong>2-Step Verification</strong> and follow the
                           prompts to set it up.
                        </li>
                     </ul>
                  </div>

                  <div className="mb-4">
                     <p className={`font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
                        2. Generate the App Password:
                     </p>
                     <ul className="list-disc ml-6 space-y-2">
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           After enabling 2-Step Verification, return to the App Passwords page:{' '}
                           <a
                              href="https://myaccount.google.com/apppasswords"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline">
                              https://myaccount.google.com/apppasswords
                           </a>
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           You may be prompted to sign in again.
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           Under "Select app," choose <strong>Mail</strong>.
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           Under "Select device," choose <strong>Other (Custom name)</strong>.
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           Enter a name (e.g., "mailer") and click <strong>Generate</strong>.
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           A 16-character app password will appear. <strong>Copy this password</strong>.
                        </li>
                     </ul>
                  </div>

                  <div
                     className={`
        p-4 rounded-lg border-l-4
        ${isDark ? 'bg-yellow-900/30 border-yellow-500' : 'bg-yellow-50 border-yellow-400'}
      `}>
                     <p className={`font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>Important Notes:</p>
                     <ul className="space-y-2">
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           App passwords are only available if 2-Step Verification is enabled.
                        </li>
                        <li className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                           If you change your Google account password, previously generated app passwords will be
                           revoked.
                        </li>
                     </ul>
                  </div>
               </ModalBody>
            </ModalContent>
         </Modal>

         <QrCodeModal isOpen={isOpenQrCode} onClose={onCloseQrCode} />
      </>
   );
};

export default CompanySettingForm;
